import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BehaviorSubject, catchError, map, Observable, of, switchMap, tap, throwError } from 'rxjs';
import { environment } from 'src/app/environments/environment';
import { SnapshotService } from './snapshot.service';

@Injectable({
  providedIn: 'root',
})
export class CustomsnapshotService {
  isAdditionalConfig: boolean = false;
  additionalColumnMetricData: { [key: number]: string } = {
    1: 'Variable- Aggregated',
    2: 'Rank',
  };
  pageCount: any = 1;
  constructor(
    private http: HttpClient,
    private _configService: SnapshotService
  ) {}
audienceCohortType:string='NA';
  //specifically for custom metrics
  uniqueAudienceData: any[] = [];
  uniqueBrandData: any[] = [];
  addNumeraleventdata: any;
  handleNumeraleventdata: any;
  uniqueMetricOptions :any[] = [];
  // used for funnel multi snapshots only

  // private selectedBrand= new BehaviorSubject<string>('');
  // selectedBrand$ = this.selectedBrand.asObservable();

  // updateSelectedBrand(param:any){
  //  this.selectedBrand.next(param);

  // }
  
  elementListItems: any = [];
  private selectedBrandMap = new BehaviorSubject<{ [key: string]: string }>({});
  selectedBrandMap$ = this.selectedBrandMap.asObservable();
  funnelChartSelectedItem$ = new BehaviorSubject<string>('');

  updateSelectedBrand(id: string, param: string) {
    const currentMap = this.selectedBrandMap.value;
    currentMap[id] = param;
    this.selectedBrandMap.next(currentMap);
  }

  getFunnelChartSelectedItem() {
    return this.selectedBrandMap$.pipe(
      map((brand) => Object.values(brand)[0] || ''),
      tap((brand) => this.funnelChartSelectedItem$.next(brand))
    );
  }

  getSelectedBrand(id: string) {
    return this.selectedBrandMap$.pipe(map((map) => map[id] || ''));
  }

  // private brandListSource = new BehaviorSubject<any[]>([]); // Initialize with an empty array or default value
  // brandList$ = this.brandListSource.asObservable();

  // updateBrandList(param1:any,param2:any) {
  //   this.brandListSource.next([param1,param2]); // Notify all subscribers
  // }
  private brandListMap = new BehaviorSubject<{ [key: string]: any[] }>({});
  brandListMap$ = this.brandListMap.asObservable();

  updateBrandList(id: string, param1: any, param2: any) {
    const currentMap = this.brandListMap.value;
    currentMap[id] = [param1, param2];
    this.brandListMap.next(currentMap);
  }

  getBrandList(id: string) {
    return this.brandListMap$.pipe(map((map) => map[id] || []));
  }

  private selectedMetricMap = new BehaviorSubject<{ [key: string]: string }>({});
  selectedMetricMap$ = this.selectedMetricMap.asObservable();

  updateSelectedMetric(id: string, metric: string) {
    const currentMap = this.selectedMetricMap.value;
    currentMap[id] = metric;
    this.selectedMetricMap.next(currentMap);
  }

  getSelectedMetric(id: string) {
    return this.selectedMetricMap$.pipe(map((map) => map[id] || ''));
  }

  getSelectedMetricSync(id: string): string {
    return this.selectedMetricMap.value[id] || '';
  }

  getAllSelectedMetrics(): string[] {
    return Object.values(this.selectedMetricMap.value).filter(v => !!v);
  }

  subsectionlist: any = [];
  snapshot: any = [];
  client: any = '';
  sectionList: any = [];
  apiBaseUrl = environment.baseApiUrl + 'api/';
  maxWidgetSelection = 16;
  selectedSnapshotName: any;
  recievedStatusDataOnBackButtonClick: any;
  selectedSnapshotType: any;
  showPreviewStatus: boolean = false;
  selectedSection: any;
  selectedSubsection: any = undefined;
  widgetSaveObjectCustom: any = [];
  widgets: any = [];
  widgetSubmitObjectCustom: any = [];
  widgetSaveObjectCustomForPreview: any = [];
  layoutSubmitFlag: any;
  isBack: boolean = false;
  dataFromPageDetail: any;
  dataFromPageDetailForPreview: any;
  fromBackButton: boolean = false;
  backFromPreview: any;
  checkDeleteClick: any;
  metricData: any = [];
  disablePreviewOnCustomizationSave: number = 0;
  widgetCustomMetrics: any;
  widgetAllCustomMetrics: any;
  elementLists = [
    {
      sortId: 1,
      name: 'Info Text',
      applicableCharts: {
        singleBrand: ['All'], // Applies to all chart types in Single Brand Snapshot
        multiBrand: ['All'], // Applies to all chart types in Multi Snapshot
      },
    },
    {
      sortId: 2,
      name: 'Trendline',
      applicableCharts: {
        singleBrand: ['All'], // Applies to all chart types in Single Brand Snapshot
        multiBrand: ['All'], // Applies to all chart types in Multi Snapshot
      },
    },
    {
      sortId: 3,
      name: 'Trend Area',
      applicableCharts: {
        singleBrand: ['All'], // Applies to all chart types in Single Brand Snapshot
        multiBrand: ['All'], // Applies to all chart types in Multi Snapshot
      },
    },
    {
      sortId: 4,
      name: 'Sorting (Default/Ascending/Descending)',
      applicableCharts: {
        singleBrand: [
          'Vertical Bar Chart',
          'Vertical Lollipop  Chart',
          'Horizontal Bar Chart',
          'Horizontal Lollipop  Chart',
          'Horizontal Stack Bar',
          'Horizontal Stacked Chart'
        ],
        multiBrand: [
          'Vertical Bar Chart',
          'Vertical Lollipop  Chart',
          'Horizontal Bar Chart',
          'Horizontal Lollipop  Chart',
          'Horizontal Stack Bar',
          'Horizontal Stacked Chart'
        ],
      },
    },
    {
      sortId: 5,
      name: 'Top 10',
      applicableCharts: {
        singleBrand: [
          'Vertical Bar Chart',
          'Vertical Lollipop  Chart',
          'Horizontal Bar Chart',
          'Horizontal Lollipop  Chart',
        ],
        multiBrand: ['NA'], // Not applicable for Multi Snapshot
      },
    },
    {
      sortId: 6,
      name: 'Selected list',
      applicableCharts: {
        singleBrand: ['NA'],
        multiBrand: ['01/Pie Chart', 'Scatter Chart', 'Bubble Chart'],
      },
    },
    {
      sortId: 7,
      name: 'Stack : Metric',
      applicableCharts: {
        singleBrand: ['NA'], // Not applicable for Single Brand Snapshot
        multiBrand: ['NA'], // Not applicable for Multi Snapshot
      },
    },
    {
      sortId: 8,
      name: 'X axis Gridlines',
      applicableCharts: {
        singleBrand: ['Horizontal Bar Chart', 'Horizontal Lollipop  Chart' ,'Horizontal Stack Bar','Vertical Stacked Chart','Vertical Stack Bar','Trend as Widget'],
        multiBrand: ['Horizontal Bar Chart', 'Horizontal Lollipop  Chart','Vertical Cluster Bar','Horizontal Cluster Bar','Horizontal Stack Bar','Vertical Stacked Chart','Vertical Stack Bar','Trend as Widget'],
      },
    },
    {
      sortId: 9,
      name: 'Y axis Gridlines',
      applicableCharts: {
        singleBrand: ['Vertical Bar Chart', 'Vertical Lollipop  Chart','Horizontal Stack Bar','Vertical Stacked Chart','Vertical Stack Bar','Trend as Widget'],
        multiBrand: ['Vertical Bar Chart', 'Vertical Lollipop  Chart','Horizontal Stack Bar','Vertical Stacked Chart','Vertical Stack Bar','Trend as Widget'],
      },
    },
    {
      sortId: 10,
      name: 'showLegend',
      applicableCharts: {
        singleBrand: ['All'], // Applies to all chart types in Single Brand Snapshot
        multiBrand: ['All'], // Applies to all chart types in Multi Snapshot
      },
    },
  ];
  chartImagesPreviewList: any = {
    'Vertical Bar Chart':
      'assets/ImagesSnapshot/ChartPreviewImages/Vertical Bar.png',
    'Vertical Cluster Bar':
      'assets/ImagesSnapshot/ChartPreviewImages/Vertical Bar.png',
    'Horizontal Bar Chart':
      'assets/ImagesSnapshot/ChartPreviewImages/Horizontal Bar.png',
    'Horizontal Cluster Bar ':
      'assets/ImagesSnapshot/ChartPreviewImages/Horizontal Clustered Bar.png',
    'Area Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Area Chart.png',
    'Line Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Line chart.png',
    'Vertical Lollipop Chart':
      'assets/ImagesSnapshot/ChartPreviewImages/Vertical lollipop Chart.png',
    'Horizontal Lollipop Chart':
      'assets/ImagesSnapshot/ChartPreviewImages/Horizontal lollipop.png',
    'Cluster Lollipop Chart':
      'assets/ImagesSnapshot/ChartPreviewImages/Cluster lollipop.png',
    '01/PIE CHART': 'assets/ImagesSnapshot/ChartPreviewImages/Pie 01.png',
    '02/PIE CHART': 'assets/ImagesSnapshot/ChartPreviewImages/Pie 02.png',
    '03/PIE CHART': 'assets/ImagesSnapshot/ChartPreviewImages/Pie 03.png',
    '04/PIE CHART': 'assets/ImagesSnapshot/ChartPreviewImages/Pie 04.png',
    '05/PIE CHART': 'assets/ImagesSnapshot/ChartPreviewImages/Pie 05.png',
    '06/PIE CHART': 'assets/ImagesSnapshot/ChartPreviewImages/Pie 06.png',
    '07/PIE CHART': 'assets/ImagesSnapshot/ChartPreviewImages/Pie 07.png',
    '08/PIE CHART': 'assets/ImagesSnapshot/ChartPreviewImages/Pie 08.png',
    '09/PIE CHART': 'assets/ImagesSnapshot/ChartPreviewImages/Pie 09.png',
    '10/PIE CHART': 'assets/ImagesSnapshot/ChartPreviewImages/Pie 10.png',
    'Propeller Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Pie 02.png',
    'Scatter Chart':
      'assets/ImagesSnapshot/ChartPreviewImages/Scatter Chart.png',
    'Quadrant Scatter Chart':
      'assets/ImagesSnapshot/ChartPreviewImages/Quadrant Scatter Chart.png',
    'Bubble Chart': 'assets/ImagesSnapshot/ChartPreviewImages/Bubble Chart.png',
    'Quadrant Bubble Chart':
      'assets/ImagesSnapshot/ChartPreviewImages/Quadrant Bubble Chart.png',
    'Vertical Stack Bar':
      'assets/ImagesSnapshot/ChartPreviewImages/Vertical Stacked.png',
    'Horizontal Stack Bar':
      'assets/ImagesSnapshot/ChartPreviewImages/Horizontal Stacked.png',
    'FUNNEL CHART': 'assets/ImagesSnapshot/ChartPreviewImages/Funnel Chart.png',
    Table: 'assets/ImagesSnapshot/ChartPreviewImages/Table.jpg',
    'spider/radar': 'assets/ImagesSnapshot/ChartPreviewImages/RadarChart.png',
    'Fill Chart': 'assets/ImagesSnapshot/ChartPreviewImages/FillChart.png',
    Gauge: 'assets/ImagesSnapshot/ChartPreviewImages/GaugeChart.png',
    'Trend as Widget':
      'assets/ImagesSnapshot/ChartPreviewImages/Line chart.png',
  };

  inputTypeConstant = [
    { item: 'Widget Name', inputType: 'text' },
    {
      item: 'Number of Levels',
      inputType: 'dropdown',
      options: [
        { value: 2, label: '2' },
        { value: 3, label: '3' },
        { value: 4, label: '4' },
        { value: 5, label: '5' },
        { value: 6, label: '6' },
        { value: 7, label: '7' },
        { value: 8, label: '8' },
      ],
    },
    { item: 'Metric Selection Drop down', inputType: 'checkboxlist' },
  
    {item:'Additional KPI'  , inputType:'checkboxlist'},
    { item: 'Label Orientation', inputType: 'images' },
   
    {
      item: 'Decimal Round off',
      inputType: 'dropdown',
      options: [
        { value: 2, label: 'Two Decimal Point' },
        { value: 1, label: 'One Decimal Point' },
        { value: 0, label: 'None' },
      ],
      className: 'DataLabelGrouping',
    },
    {
      item: 'Info Button',
      inputType: 'textArea',
      options: [
        { value: 'none', label: 'None' },
        { value: 'fom', label: 'FOM Tooltip' },
        { value: 'custom', label: 'Custom' },
      ],
    },
    { item: 'Start Value', inputType: 'textArea1', value: 0 },
    { item: 'End Value', inputType: 'textArea1', value: 0 },
    { item: 'Target Value', inputType: 'textArea1', value: 0 },
    {
      item: 'Legend',
      inputType: 'images',
      options: [
        {
          value: 'enable',
          label: 'Enable',
          selected: true,
          imgClassName: 'legendEnable',
          selectedImgClassName: 'legendEnableSelected',
        },
        {
          value: 'disable',
          label: 'Disable',
          selected: false,
          imgClassName: 'legendDisable',
          selectedImgClassName: 'legendDisableSelected',
        },
      ],
      className: 'Legend',
    },
    {
      item: 'Legend position',
      inputType: 'images',
      options: [
        {
          value: 'left',
          label: 'Left',
          selected: false,
          imgClassName: 'legendLeft',
          selectedImgClassName: 'legendLeftSelected',
        },
        {
          value: 'bottom',
          label: 'Bottom',
          selected: true,
          imgClassName: 'legendBottom',
          selectedImgClassName: 'legendBottomSelected',
        },
        {
          value: 'right',
          label: 'Right',
          selected: false,
          imgClassName: 'legendRight',
          selectedImgClassName: 'legendRightSelected',
        }, // Add this option for 'Right'
      ],
      className: 'LegendGrouping',
    },
    {
      item: 'Data Label',
      inputType: 'toggle',
      options: [
        { value: 'enable', label: 'On', selected: true },
        { value: 'disable', label: 'Off', selected: false },
      ],
      className: 'DataLabel',
    },
     {
      item: '100% Stack chart',
      inputType: 'toggle',
      options: [
        { value: 'enable', label: 'On', selected: false },
        { value: 'disable', label: 'Off', selected: true },
      ],
      className: '100%Stackchart',
    },
     {
      item: 'Transpose',
      inputType: 'toggle',
      options: [
        { value: 'enable', label: 'On', selected: false },
        { value: 'disable', label: 'Off', selected: true },
      ],
      className: 'StackFormat',
    },
     {
      item: 'BD_BI Toggle',
      inputType: 'toggle',
      options: [
        { value: 'enable', label: 'Brand Dependent', selected: true },
        { value: 'disable', label: 'Brand Independent', selected: false },
      ],
      className: 'BD_BI_Toggle',
    },
    {
    item: 'Audience Drop down',
    inputType: 'dropdown',
    options: [], // Will be populated from uniqueAudienceData
    getDynamicOptions: () => {
      return this.uniqueAudienceData.map((item, index) => ({
        value: `${item.variable_code}_${item.response_code}`,
        label: item.Audience_WidgetMapping_Variable,
        is_selected:false,
        data: item // Store complete item for reference
      }));
    }
  },
   {
    item: 'Brand Drop down',
    inputType: 'dropdown',
    options: [], // Will be populated from uniqueBrandData
    getDynamicOptions: () => {
      return this.uniqueBrandData.map((item, index) => ({
        value: `${item.response_label}`,
        label: item.response_label,
        is_selected:false,
        data: item // Store complete item for reference
      }));
    }
  },
    {
      item: 'Data Label Colour',
      inputType: 'color',
      value: '#000000',
      className: 'DataLabelGrouping',
    },
    {
      item: 'Data Label Size',
      inputType: 'dropdown',
      options: [
        { value: '0.7em', label: '0.7 Em' },
        { value: '0.8em', label: '0.8 Em' },
        { value: '0.9em', label: '0.9 Em' },
        { value: '1em', label: '1 Em' },
      ],
      className: 'DataLabelGrouping',
    },
    {
      item: 'Data Label Property',
      inputType: 'dropdown',
      options: [
        { value: 'datalabel', label: 'Default ' },
        { value: 'change', label: 'Change Versus ' },
        {
          value: 'significance + changeVs',
          label: 'Change Versus + Significance',
        },

        { value: 'significance', label: 'Significance ' },
        { value: 'significance2', label: 'Significance Level2' },

        { value: 'ls', label: 'Low Sample ' },
      ],
      className: 'DataLabelGrouping',
    },
    {
      item: 'Quadrant Position',
      inputType: 'dropdown',
      options: [
        { value: 'average', label: 'Average of the axis coordinates' },
        { value: 'fixed', label: 'Fixed' },
        { value: 'midpoint', label: 'Midpoint of min and max' },
      ],
    },
    {
      item: 'Quadrant Dash Style ',
      inputType: 'dropdown',
      options: [
        { value: 'none', label: 'None' },
        { value: 'dash', label: 'Dash' },
        { value: 'shortdash', label: 'ShortDash' },
        { value: 'dot', label: 'Dot' },
        { value: 'solid', label: 'Solid' },
        { value: 'shortDashDot', label: 'ShortDashDot' },
        { value: 'shortDashDotDot', label: 'ShortDashDotDot' },
        { value: 'longDash', label: 'LongDash' },
        { value: 'longDashDot', label: 'LongDashDot' },
      ],
    },
    { item: 'Quadrant Color Code', inputType: 'color' },
    { item: 'Fixed X-Axis Value', inputType: 'text' },
    { item: 'Fixed Y-Axis Value', inputType: 'text' },
    { item: 'Trendline', inputType: 'checkbox' },
    { item: 'Trend Area', inputType: 'checkbox' },
    { item: 'Sorting', inputType: 'checkbox' },
    { item: 'Top 10', inputType: 'checkbox' },
    { item: 'Selected/ All brands', inputType: 'checkbox' },
    // { item: '100% Stack chart', inputType: 'checkbox' },
    { item: 'Stack position', inputType: 'toggle' },
    { item: 'Image Fill', inputType: 'checkbox' },
    { item: 'Axis Image', inputType: 'checkbox' },
    { item: 'Line Style', inputType: 'dropdown' },
    { item: 'X Axis Gridlines', inputType: 'checkbox' },
    { item: 'Y Axis Gridlines', inputType: 'checkbox' },
    {
      item: 'Data Label Overlap',
      inputType: 'checkbox',
      className: 'DataLabelGrouping',
    },
    { item: 'Selected list', inputType: 'checkbox' },
    { item: 'Trendline in Exports ', inputType: 'OutsideCheckbox' },
    { item: 'Column Header Sorting', inputType: 'checkbox' },
    { item: 'Hide NA', inputType: 'checkbox' },
    { item: 'Highlight Column Total ', inputType: 'checkbox' },
    { item: 'Highlight  Row Total ', inputType: 'checkbox' },
    { item: 'Transpose ', inputType: 'checkbox' },
    { item: 'Freeze First Column', inputType: 'checkbox' },
    { item: 'Freeze First Row ', inputType: 'checkbox' },
    { item: 'Top 10', inputType: 'checkbox' },
    { item: 'Selected list', inputType: 'checkbox' },
    { item: 'Data Label Overlap ', inputType: 'checkbox' },
    { item: 'Axes', inputType: 'checkbox' },
    { item: 'Sector fill', inputType: 'checkbox' },
    {
      item: 'Column Header Alignment',
      inputType: 'dropdown',
      options: [
        { value: 'center', label: 'Center align' },
        { value: 'left', label: 'left align' },
        { value: 'right', label: 'right align' },
      ],
      className: 'FirstColumnGrouping',
    },
    {
      item: 'Row Header Alignment',
      inputType: 'dropdown',
      options: [
        { value: 'center', label: 'Center align' },
        { value: 'left', label: 'left align' },
        { value: 'right', label: 'right align' },
      ],
      className: 'FirstRowGrouping',
    },
    {
      item: 'Visual Option',
      inputType: 'dropdown',
      options: [{ value: 'style1', label: 'style1' }],
    },
    {
      item: 'Data Label Alignment',
      inputType: 'dropdown',
      options: [
        { value: 'center', label: 'Center align' },
        { value: 'left', label: 'left align' },
        { value: 'right', label: 'right align' },
      ],
      //className: 'DataLabelGrouping',
    },
    {
      item: 'Calculation Logic',
      inputType: 'customdropdown',
      selectedValue: 'None',
      options: [
        {
          value: 'None',
          label: 'None',
          inputType: 'colorpicker',
          isSelected: true,
          color: '#858080',
          id: 'Calculation-None',
        },
        {
          value: 'BIPS',
          label: 'BIPS',
          options: [
            {
              value: 'negativeRange',
              inputType: 'textbox-colorpicker',
              label: 'Negative Range:',
              placeholder: '-X',
              inputvalue: '-3',
              color: '#DD3C3C',
              id: 'BIPS-Negative',
            },
            {
              value: 'positiveRange',
              inputType: 'textbox-colorpicker',
              label: 'Positive Range : ',
              placeholder: 'Y',
              inputvalue: '3',
              color: '#2AC073',
              id: 'BIPS-Positive',
            },
            {
              value: 'bipsBrands',
              inputType: 'buttongroup',
              label: '',
              id: 'BIPS-Brands',
              options: [
                { value: 'default', label: 'All Brands', selected: true },
                { value: 'configurableBrands', label: 'Configurable Brands', selected: false },
              ],
            },
          ],
          isSelected: false,
          id: 'Calculation-BIPS',
        },
      ],
      //className: 'DataLabelGrouping',
    },
    {
      item: 'Border Thickness',
      inputType: 'dropdown',
      options: [
        { value: 'All', label: 'All borders' },
        { value: 'none', label: 'No borders' },
        { value: 'Outside', label: 'Outside Border' },
      ],
      //className: 'DataLabelGrouping',
    },
    {
      item: 'Column Header Font Size',
      inputType: 'dropdown',
      options: [
        { value: '0.7em', label: '0.7 Em' },
        { value: '0.8em', label: '0.8 Em' },
        { value: '0.9em', label: '0.9 Em' },
        { value: '1em', label: '1 Em' },
      ],
      className: 'FirstColumnGrouping',
    },
    {
      item: 'Row Header Font Size',
      inputType: 'dropdown',
      options: [
        { value: '0.7em', label: '0.7 Em' },
        { value: '0.8em', label: '0.8 Em' },
        { value: '0.9em', label: '0.9 Em' },
        { value: '1em', label: '1 Em' },
      ],
      className: 'FirstRowGrouping',
    },
    // {
    //   item: 'First Column as header', inputType: 'dropdown',
    //   options: [
    //     { value: 'Yes', label: 'Yes' },
    //     { value: 'No', label: 'No' },],
    //   //className: 'DataLabelGrouping',
    // },
    {
      item: 'First Column as header',
      inputType: 'OutsideCheckbox',
      className: 'FirstColumn',
    },
    {
      item: 'First Row as header',
      inputType: 'OutsideCheckbox',
      className: 'FirstRow',
    },
    {
      item: 'Enable data bars(within cells)',
      inputType: 'OutsideCheckbox',
      className: 'FirstRow',
    },
    {
      item: 'Fixed Circle Radius',
      inputType: 'text',
      className: 'FixedCircleRadius',
    },
    {
      item: 'Marker Style',
      inputType: 'dropdown',
      options: [
        { value: 'circle', label: 'Circle' },
        { value: 'diamond', label: 'Diamond' },
        { value: 'square', label: 'Square' },
        { value: 'triangle', label: 'Triangle' },
      ],
    },
    {
      item: 'Line Style ',
      inputType: 'dropdown',
      options: [
        { value: 'Solid', label: 'Solid' },
        { value: 'Dash', label: 'Dash' },
        { value: 'DashDot', label: 'DashDot' },
        { value: 'dot', label: 'Dot' },
        { value: 'LongDash', label: 'LongDash' },
        { value: 'LongDashDot', label: 'LongDashDot' },
        { value: 'LongDashDotDot', label: 'LongDashDotDot' },
      ],
    },
    {
      item: 'Gridlines dash ',
      inputType: 'dropdown',
      options: [
        { value: 'Solid', label: 'Solid' },
        { value: 'Dash', label: 'Dash' },
        { value: 'DashDot', label: 'DashDot' },
        { value: 'dot', label: 'Dot' },
        { value: 'LongDash', label: 'LongDash' },
        { value: 'LongDashDot', label: 'LongDashDot' },
        { value: 'LongDashDotDot', label: 'LongDashDotDot' },
      ],
    },
    {
      item: 'Banded Column',
      inputType: 'color',
      value: '#ffffff',
      //className: 'DataLabelGrouping',
    },
    {
      item: 'Banded Row',
      inputType: 'color',
      value: '#ffffff',
      //className: 'DataLabelGrouping',
    },
    { item: 'Gridlines colour ', inputType: 'color', value: '#D3D3D3' },
    {
      item: 'Border Colour',
      inputType: 'color',
      value: '#D3D3D3',
      className: '',
    },
    {
      item: 'Column Header Font  Colour',
      inputType: 'color',
      value: '#000000',
      className: 'FirstColumnGrouping',
    },
    {
      item: 'Column Header Cell  Colour',
      inputType: 'color',
      value: '#8505cf',
      className: 'FirstColumnGrouping',
    },
    {
      item: 'Row Header Font Colour',
      inputType: 'color',
      value: '#000000',
      className: 'FirstRowGrouping',
    },
    {
      item: 'Row Header Cell  Colour',
      inputType: 'color',
      value: '#D3D3D3',
      className: 'FirstRowGrouping',
    },
  ];

  chartCutomizationList: any = [];
  ChartPropertiesOptionSelection: any;
  prepareCustomizationList(data: any) {
    this.ChartPropertiesOptionSelection = data?.ChartPropertiesOptionSelection;
    data.ChartPropertiesOptionSelection.forEach((s: any) => {
      let group = 'Group' + s.CustomizationCharacteristicGroup;
     
    s.customizationList = data.ChartPropertiesDisplaySettings.filter(
  (m: any) => {
    
    return m[group]?.toLowerCase() == 'all';
  });
    });        
    data.ChartPropertiesOptionSelection.forEach((s: any) => {
      s.finalCustomizationList = [];
      if(s.SnapshotType=="Audience Snapshot" ){
      
      }
      s.customizationList.sort((a: any, b: any) => a.SortingOrder - b.SortingOrder);
      
      s.customizationList.forEach((ss: any) => {
        if(ss.CustomizationHeaders == "Audience Drop down"){
         
        }
        let c: any = this.inputTypeConstant.find(
          (cc: any) => cc.item == ss.CustomizationHeaders
        );
        let m: any = {
          customization: `${ss.CustomizationHeaders} : `,
          func: 'applycustomization',
          inputType: c?.inputType,
          className: c?.className ? c?.className : '',
          id: ss.CustomizationHeaders,
          options: c?.options ? c?.options : [],
          value: c?.value ? c?.value : '',
          selectedValue: c?.selectedValue ? c?.selectedValue : '',
        };
        if (ss.CustomizationHeaders == 'Additional KPI') {
          let metricgroup = this.metricData.find(
            (m: any) => m.option == 'METRIC GROUP'
          );
          if (metricgroup) {
            metricgroup.Level2 = metricgroup?.Level2?.map(
              (item: any, index: any) => ({
                ...item,
                index,
              })
            );
          }
          
          let metric = this.metricData
            .find((m: any) => m.option == 'METRICS')
            ?.Level2?.filter((mm: any) => mm.option != '');
          if (metric) {
            metric = metric.map((item: any, index: any) => ({
              ...item,
              index,
            }));
          }

          let custommetrics = this.metricData
            .find((m: any) => m.option == 'CUSTOM METRICS')
            ?.Level2?.filter((mm: any) => mm.option != '');
          if (custommetrics) {
            custommetrics = custommetrics?.map(
              (item: any, index: any) => ({
                ...item,
                index,
              })
            );
          }

       
            let dropdownMetricData = JSON.parse(JSON.stringify(this.metricData));
          if (s.MetricDropdown == 1 || s.MetricDropdown == 2) {
            dropdownMetricData = dropdownMetricData.filter(
              (m: any) => m.option != 'METRIC GROUP'
            );
          }
           dropdownMetricData = dropdownMetricData.map((m: any) => {
    m.type = 'radio';
    return m;
  });
  
          let option = _.cloneDeep(dropdownMetricData);
          
          m = {
            customization: `${'Additional KPI'} : `,
            func: 'applycustomization',
            inputType: 'radio',
            className: '',
            id: 'Additional KPI',
            options: _.cloneDeep(option),
            value: c?.value ? c?.value : '',
            select: 3, // Checkbox list selection
            showDropdown: false,
            checkedList: [],
            maxMetricLimit: ss.MaxKPILimit || 10, // Use MaxKPILimit or default to 10
            selectOrder: 0,
          };
          s.finalCustomizationList.push(m);
        } else if (ss.CustomizationHeaders == 'Metric Selection Drop down') {
          let metricgroup = this.metricData.find(
            (m: any) => m.option == 'METRIC GROUP'
          );
          if (metricgroup) {
            metricgroup.Level2 = metricgroup?.Level2?.map(
              (item: any, index: any) => ({
                ...item, // Keep all existing properties
                index, // Add the index property
              })
            );
          }
          let metric = this.metricData
            .find((m: any) => m.option == 'METRICS')
            ?.Level2?.filter((mm: any) => mm.option != '');
          if (metric) {
            metric = metric.map((item: any, index: any) => ({
              ...item, // Keep all existing properties
              index, // Add the index property
            }));
          }

          let custommetrics = this.metricData
            .find((m: any) => m.option == 'CUSTOM METRICS')
            ?.Level2?.filter((mm: any) => mm.option != '');
          if (custommetrics) {
            custommetrics.Level2 = custommetrics?.map(
              (item: any, index: any) => ({
                ...item, // Keep all existing properties
                index, // Add the index property
              })
            );
          }

          let dropdownMetricData = JSON.parse(JSON.stringify(this.metricData));
          if (s.MetricDropdown == 1 || s.MetricDropdown == 2) {
            dropdownMetricData = dropdownMetricData.filter(
              (m: any) => m.option != 'METRIC GROUP'
            );
          }
          if (s.MetricDropdown == 1) {
            dropdownMetricData = dropdownMetricData.map((m: any) => {
              m.type = 'radio';
              return m;
            });
          }
          // If MetricDropdown is 3, set METRIC GROUP to radio type
          if (s.MetricDropdown == 3) {
            dropdownMetricData = dropdownMetricData.map((m: any) => {
              if (m.option == 'METRIC GROUP') {
                m.type = 'radio';
              }
              return m;
            });
          }
          let metricInputType = 'checkboxlist'; // default
if (s.MetricDropdown == 1 || s.MetricDropdown == 3 ) {
  metricInputType = 'radio';
} else if (s.MetricDropdown == 4) {
  metricInputType = 'checkbox'; // For Audience Snapshot
}
          //let option = (s.MetricDropdown == 1) ? metric : (s.MetricDropdown == 2 ? metric : this.metricData);
          let option = dropdownMetricData;
          option = _.cloneDeep(option);
          if (s.IsMetricDropdownXaxis) {
            m = {
              customization: `${'XAxis Metric'} : `,
              func: 'applycustomization',
              inputType: c?.inputType,
              className: '',
              id: 'XAxis Metric',
              options: _.cloneDeep(option),
              value: c?.value ? c?.value : '',
              select: s.MetricDropdown,
              showDropdown: false,
              checkedList: [],
              maxMetricLimit: s.MaxMetricLimit,
              selectOrder: 0,
            };
            s.finalCustomizationList.push(m);
          }
          if (s.IsMetricDropdownYaxis) {
            m = {
              customization: `${'YAxis Metric'} : `,
              func: 'applycustomization',
              inputType: c?.inputType,
              className: '',
              id: 'YAxis Metric',
              options: _.cloneDeep(option),
              value: c?.value ? c?.value : '',
              select: s.MetricDropdown,
              showDropdown: false,
              checkedList: [],
              maxMetricLimit: s.MaxMetricLimit,
              selectOrder: 0,
            };
            s.finalCustomizationList.push(m);
          }
          if (s.IsMetricDropdownZaxis) {
            m = {
              customization: `${'ZAxis Metric'} : `,
              func: 'applycustomization',
              inputType: c?.inputType,
              className: '',
              id: 'ZAxis Metric',
              options: _.cloneDeep(option),
              value: c?.value ? c?.value : '',
              select: s.MetricDropdown,
              showDropdown: false,
              checkedList: [],
              maxMetricLimit: s.MaxMetricLimit,
              selectOrder: 0,
            };
            s.finalCustomizationList.push(m);
          }
          if (
            !s.IsMetricDropdownXaxis &&
            !s.IsMetricDropdownYaxis &&
            !s.IsMetricDropdownZaxis
          ) {
            m = {
              customization: `${'Metric'} : `,
              func: 'applycustomization',
              inputType: c?.inputType,
              className: '',
              id: 'Metric',
              options: _.cloneDeep(option),
              value: c?.value ? c?.value : '',
              select: s.SnapshotType == "Audience Snapshot" ? 4 : s.MetricDropdown,
              showDropdown: false,
              checkedList: [],
              maxMetricLimit: s.MaxMetricLimit,
              selectOrder: 0,
            };
            s.finalCustomizationList.push(m);
          }

          if (s.IsMetricInnerCircle === 1 ) {
            let innerMetricOptions = _.cloneDeep(dropdownMetricData).map((m: any) => {
              m.type = 'radio';
              return m;
            });

            let innerM = {
              customization: `Metric Inner Circle : `,
              func: 'applycustomization',
              inputType: 'checkboxlist',
              className: '',
              id: 'Metric Inner Circle',
              options: innerMetricOptions,
              value: '',
              select: 1,
              showDropdown: false,
              checkedList: [],
              maxMetricLimit: 1,
              selectOrder: 0,
            };
            s.finalCustomizationList.push(innerM);
          }   
        }
        else if (ss.CustomizationHeaders == 'Additional Column') {
          const additionalColumnIds = String(s.additionalColumn ?? '0')
            .split(',')
            .map((value: string) => Number(value.trim()))
            .filter((value: number) => value !== 0 && !Number.isNaN(value));

          if (additionalColumnIds.length > 0) {
            const option = additionalColumnIds
              .filter((value: number) => this.additionalColumnMetricData[value])
              .map((value: number, index: number) => ({
                option: this.additionalColumnMetricData[value],
                value,
                index,
                selectOrder: index + 1,
              }));

            m = {
              customization: `${'Additional Column'} : `,
              func: 'applycustomization',
              inputType: 'checkboxlist',
              className: '',
              id: 'additionalColumn',
              options: _.cloneDeep(option),
              value: c?.value ? c?.value : '',
              select: s.SnapshotType == "Audience Snapshot" ? 4 : s.MetricDropdown,
              showDropdown: false,
              checkedList: [],
              maxMetricLimit: s.MaxMetricLimit,
              selectOrder: 0,
            };
            s.finalCustomizationList.push(m);
          }

          
          
        }
        else if(ss.CustomizationHeaders =='Audience Drop down'){
            let audienceOptions = this.uniqueAudienceData.map((item, index) => ({
      option: item.Audience_WidgetMapping_Variable || `${item.variable_code} - ${item.response_code}`,
      value: `${item.variable_code}_${item.response_code}`,
      is_selected: item.is_selected || false,
      index: index,
      data: item // Store complete item for reference
    }));
let metricInputType = 'checkboxlist'; // default
if (s.MetricDropdown == 1  ) {
  metricInputType = 'radio';
} else if (s.MetricDropdown == 4) {
  metricInputType = 'checkboxlist'; // For Audience Snapshot
}
    m = {
      customization: `${'Audience Drop down'} : `,
      func: 'applycustomization',
      inputType: metricInputType,
      metricInputType: metricInputType,
      className: '',
      id: 'Audience Drop down',
      options: audienceOptions,
      value: c?.value ? c?.value : '',
      showDropdown: false,
      checkedList: [],
      maxAudienceLimit: s.MaxMetricLimit || 6, // Add limit if needed
      selectOrder: 0,
    };
    s.finalCustomizationList.push(m);
    if (s.IsMetricInnerCircle === 1) {
      let innerAudienceOptions = audienceOptions.map((a: any) => ({
        ...a,
        is_selected: false,
        is_excluded: false
      }));
      let innerA = {
        customization: `Metric Inner Circle : `,
        func: 'applycustomization',
        inputType: 'checkboxlist',
        className: '',
        id: 'Audience Inner Circle',
        options: innerAudienceOptions,
        value: '',
        showDropdown: false,
        checkedList: [],
        maxAudienceLimit: 1,
        selectOrder: 0,
      };
      s.finalCustomizationList.push(innerA);
    }
        }
           else if(ss.CustomizationHeaders =='Brand Drop down'){
            let brandOptions = this.uniqueBrandData.map((item, index) => ({
      option: item.response_label || `${item.response_label}`,
      value: `${item.response_label}_${item.response_label}`,
      is_selected: item.is_selected || false,
      index: index,
      data: item // Store complete item for reference
    }));

    m = {
      customization: `${'Brand Drop down'} : `,
      func: 'applycustomization',
      inputType: 'checkboxlist', // or 'dropdown' based on your requirement
      className: '',
      id: 'Brand Drop down',
      options: brandOptions,
      value: c?.value ? c?.value : '',
      showDropdown: false,
      checkedList: [],
    
      selectOrder: 0,
    };
    s.finalCustomizationList.push(m);
        }
        else if (ss.CustomizationHeaders == 'Label Orientation') {
          if (s.IsXaxisLabelOrientation) {
            m = {
              customization: `${'X Axis Label Orientation'} : `,
              func: 'applycustomization',
              inputType: c?.inputType,
              className: '',
              id: 'X Axis Label Orientation',
              value: c?.value ? c?.value : '',
              options: [
                {
                  value: 'horizontal',
                  label: 'Horizontal',
                  selected: true,
                  imgClassName: 'axisHorizontal',
                  selectedImgClassName: 'axisHorizontalSelected',
                },
                {
                  value: 'vertical',
                  label: 'Vertical',
                  selected: false,
                  imgClassName: 'axisVertical',
                  selectedImgClassName: 'axisVerticalSelected',
                },
                {
                  value: 'angled',
                  label: 'Angled',
                  selected: false,
                  imgClassName: 'axisAngled',
                  selectedImgClassName: 'axisAngledSelected',
                },
              ],
            };
            s.finalCustomizationList.push(m);
          }
          if (s.IsYaxisLabelOrientation) {
            m = {
              customization: `${'Y Axis Label Orientation'} : `,
              func: 'applycustomization',
              inputType: c?.inputType,
              className: '',
              id: 'Y Axis Label Orientation',
              value: c?.value ? c?.value : '',
              options: [
                {
                  value: 'horizontal',
                  label: 'Horizontal',
                  selected: true,
                  imgClassName: 'axisHorizontal',
                  selectedImgClassName: 'axisHorizontalSelected',
                },
                {
                  value: 'vertical',
                  label: 'Vertical',
                  selected: false,
                  imgClassName: 'axisVertical',
                  selectedImgClassName: 'axisVerticalSelected',
                },
                {
                  value: 'angled',
                  label: 'Angled',
                  selected: false,
                  imgClassName: 'axisAngled',
                  selectedImgClassName: 'axisAngledSelected',
                },
              ],
            };
            s.finalCustomizationList.push(m);
          }
          if (s.IsZaxisLabelOrientation) {
            m = {
              customization: `${'Z Axis Label Orientation'} : `,
              func: 'applycustomization',
              inputType: c?.inputType,
              className: '',
              id: 'Z Axis Label Orientation',
              value: c?.value ? c?.value : '',
              options: [
                {
                  value: 'horizontal',
                  label: 'Horizontal',
                  selected: true,
                  imgClassName: 'axisHorizontal',
                  selectedImgClassName: 'axisHorizontalSelected',
                },
                {
                  value: 'vertical',
                  label: 'Vertical',
                  selected: false,
                  imgClassName: 'axisVertical',
                  selectedImgClassName: 'axisVerticalSelected',
                },
                {
                  value: 'angled',
                  label: 'Angled',
                  selected: false,
                  imgClassName: 'axisAngled',
                  selectedImgClassName: 'axisAngledSelected',
                },
              ],
            };
            s.finalCustomizationList.push(m);
          }
        } else {
          s.finalCustomizationList.push(m);
        }
      });
      s.finalCustomizationList = _.uniqBy(
        s.finalCustomizationList,
        (item: any) => (item?.id || item?.customization || '').replace(/\s+/g, '').toLowerCase()
      );
    });
    this.chartCutomizationList = data.ChartPropertiesOptionSelection;
    
   
    

  }

  getChartCustomization(
    chartName: string,
    snapshotType: string,
    cohortType?:string
  ): Observable<{ list: any[]; metricDropdownOutput: any }> {
    const processCustomizationList = (
      result: any[],
      snapshotType: string,
      chartType: string,
      cohortType?:string,
      metricdropdownoutput?:number
    ) => {
      return result.filter((item) => {
        const customizationMatch = item.id.replace(/\s+/g, '').toLowerCase();
        const element = this.elementLists.find(
          (e: any) =>
            e.name.toLowerCase().replace(/\s+/g, '') === customizationMatch
        );
        if (!element) return true;

        const applicableCharts =
          snapshotType === 'Single Brand'
            ? element.applicableCharts.singleBrand
            : element.applicableCharts.multiBrand;

        // If the list contains only "ALL", keep the item
        if (applicableCharts.length === 1 && applicableCharts[0] === 'All') {
          return true;
        }

        // Remove "NA" items and items not matching the given chartType
        return (
          applicableCharts.includes(chartType.trim()) &&
          item.customization.toLowerCase() !== 'na'
        );
      });
    };
const normalize = (val: any) => (val || '').replace(/\s+/g, '').toLowerCase();

const filteredList = _.cloneDeep(this.chartCutomizationList).filter((c: any) =>
  normalize(c.SnapshotType) === normalize(snapshotType) &&
  normalize(c.Chart) === normalize(chartName) &&
  (cohortType
    ? normalize(c.cohortType) === normalize(cohortType)
    : true)
);


const vcbEntries = this.chartCutomizationList.filter((c: any) => normalize(c.Chart) === normalize(chartName));
const vcbAudienceEntries = this.chartCutomizationList.filter((c: any) =>
  normalize(c.Chart) === normalize(chartName) &&
  normalize(c.SnapshotType) === normalize(snapshotType)
);


let result = filteredList.reduce(
  (acc: any[], curr: any) => acc.concat(curr.finalCustomizationList),
  []
);
//  let result = _.cloneDeep(this.chartCutomizationList)
//   .filter(
//     (c: any) =>
//       c.SnapshotType.replace(/\s+/g, '').toLowerCase() === snapshotType.replace(/\s+/g, '').toLowerCase() &&
//       c.Chart.trim().toLowerCase() === chartName.trim().toLowerCase() &&
//       (cohortType 
//         ? c.cohortType?.replace(/\s+/g, '').toLowerCase() === cohortType.replace(/\s+/g, '').toLowerCase()
//         : true) // If cohortType is undefined, include all items (don't filter by cohort)
//   )
//   .reduce(
//     (acc: any[], curr: any) => acc.concat(curr.finalCustomizationList),
//     []
//   );

    if (this._configService.isStaticTimeFrame) {
      result = result.filter(
        (c: any) =>
          c.id.toLowerCase() !== 'trendline' &&
          c.id.toLowerCase() !== 'trendarea'
      );
    }
    return of({
      list: processCustomizationList(result, snapshotType, chartName, cohortType, filteredList[0]?.MetricdropdownOutput),
      metricDropdownOutput: filteredList[0]?.MetricdropdownOutput
    });

    // return of(_.cloneDeep(this.chartCutomizationList)).pipe(
    //   map((list: any[]) =>
    //     list
    //       .filter(c => c.SnapshotType.replace(/\s+/g, '').toLowerCase() === snapshotType.replace(/\s+/g, '').toLowerCase() && c.Chart === chartName)
    //       .reduce((acc: any[], curr: any) => acc.concat(curr.finalCustomizationList), []) // Flattening the lists
    //   )
    // );
  }

  getVisualSelectWidgetDetails(
    snapshotData: any,
    sectionName: string,
    subsectionName: string,
    snapshotTypeName: string,
     audienceCohortType: string
  ) {
    // Find the matching snapshotType
    const snapshotType = snapshotData.snapshotType.find(
      (type: any) => type.snapshotType_name === snapshotTypeName
    );

    if (!snapshotType) {
      console.log('SnapshotType not found');
      return [];
    }

    // Find the matching section
    const section = snapshotType.section.find(
      (sec: any) => sec.section_name === sectionName
    );

    if (!section) {
      console.log('Section not found');
      return [];
    }

    // Find the matching subsection
    const subsection = section.subsection.find(
      (sub: any) => sub.subsection_name === subsectionName
    );

    if (!subsection) {
      return [];
    }

    // Extract widget details
    const widgetDetails = subsection.widget_detail
      ?.filter((w: any) => w.widgetParentChartType != 'LineChart')
      .map((widget: any) => ({
        widgetName: widget.widget_name,
        visualization: widget.widgetchart_name,
        image: this.chartImagesPreviewList[widget.widgetchartname?.trim()] || '',
        active: false,
        parent: widget.widgetParentChartType,
      }));

    return widgetDetails;
  }

  modifyWidgetsForSpecificSnapshotSection(
    snapshotData: any,
    snapshotName: string,
    sectionName: string,
    subsectionName: string,
    widgetDetails: { widgetName: string; visualization: string }[]
  ) {
    const updatedSnapshotData = {
      ...snapshotData,
      snapshotType: snapshotData.snapshotType.map((snapshotType: any) => {
        if (snapshotType.snapshotType_name === snapshotName) {
          return {
            ...snapshotType,
            section: snapshotType.section.map((section: any) => {
              if (section.section_name === sectionName) {
                return {
                  ...section,
                  subsection: section.subsection.map((subsection: any) => {
                    if (subsection.subsection_name === subsectionName) {
                      return {
                        ...subsection,
                        widget_detail: subsection.widget_detail.filter(
                          (widget: any) =>
                            widgetDetails.some(
                              (detail: any) =>
                                widget.widget_name === detail.widgetName &&
                                widget.widgetchart_name === detail.visualization
                            )
                        ),
                      };
                    } else {
                      return subsection; // Return as it was for other subsections
                    }
                  }),
                };
              } else {
                return section; // Return as it was for other sections
              }
            }),
          };
        } else {
          return snapshotType; // Return as it was for other snapshot types
        }
      }),
    };

    return updatedSnapshotData;
  }
  uploadAttributeImportanceFile(
  formData:FormData
) {



  // Must match property names in AttributeImportanceRequest
  formData.append('Action', '1'); // Upload

  formData.append('File', formData.get('file') as Blob);


  return this.http.post(
    `${this.apiBaseUrl}Snapshot/ManageAttributeImportance`,
    formData
  );
}
downloadAttributeImportanceTemplate(excelData:any) {

  const formData = new FormData();

      formData.append('Action', '2'); // DownloadTemplate
formData.append(
  'excelData',
  JSON.stringify(excelData)
);
  return this.http.post(
    `${this.apiBaseUrl}Snapshot/ManageAttributeImportance`,
    formData,
    {
      responseType: 'blob'
    }
  );
}
downloadAttributeImportance(snapshotId: string, uploadedRows: any[]) {
  const formData = new FormData();
  formData.append('Action', '3');  // Download
  formData.append('SnapshotId', snapshotId ?? '');
  formData.append('UploadedRows', JSON.stringify(uploadedRows ?? []));

  return this.http.post(
    `${this.apiBaseUrl}Snapshot/ManageAttributeImportance`,
    formData,
    { responseType: 'blob' }
  );
}
getCustomSnapshotWidgetLibrary(data: any): Observable<any> {
  return this.http.post<any>(
    `${this.apiBaseUrl}Snapshot/GetCustomSnapshotWidget`,
    data
  ).pipe(
 map(response => {
  
  //editing datalabelsize here, as in elastic search the customizationproperties are of string type and cannot directly edit the values
  try {
    let jsonData;
   
    
  if (typeof response.Data === 'string' && response.Data && response.Data.trim()) {
  try {
    jsonData = JSON.parse(response.Data);
  } catch (error) {
   
    jsonData = null; // or set a default value
  }
} else {
  // Handle empty string case
  jsonData = null; // or set a default empty object/array
}
    
 jsonData?.snapshotType?.forEach((snapshotType: any) => {
  // Iterate through each section in the snapshot type
  snapshotType.section?.forEach((section: any) => {
    // Iterate through each sub_section in the section
    section.subsection?.forEach((subSection: any) => {
      // Iterate through each widget_detail in the sub_section
      subSection.widget_detail?.forEach((widgetDetail: any) => {
        try {
          if (widgetDetail.customizationProperties && typeof widgetDetail.customizationProperties === 'string') {
            const customizationProps = JSON.parse(widgetDetail.customizationProperties);
            widgetDetail.customizationProperties = JSON.stringify(customizationProps);
          }
        } catch (error) {
          console.error('Error parsing customizationProperties:', error);
        }
      });
    });
  });
});

// Maintain the same structure as the original response
const modifiedResponse = jsonData ? {
  ...response,
  Data: typeof response.Data === 'string' ? JSON.stringify(jsonData) : jsonData
} : response;
   
    
    // Return the modified response in the same format as original
    return modifiedResponse;
    
  } catch (error) {
    console.error('Error converting to JSON:', error);
    return response; // Return original response in case of error
  }
})
  );
}
  allCustomSnapshotWidgetLibrary: any[] = []; 

  getAllCustomSnapshotWidgetLibrary(clientName: string, snapshotNames: string[]): Observable<any[]> {
  const body = {
    clientName: clientName,
    snapshotNames: snapshotNames
  };

  return this.http
    .post<any>(`${this.apiBaseUrl}Snapshot/GetAllCustomSnapshotWidgetByClient`, body)
    .pipe(
      tap((snapshotWidgetLibrary: any) => {
        if (snapshotWidgetLibrary && snapshotWidgetLibrary.Data) {
          this.allCustomSnapshotWidgetLibrary = JSON.parse(snapshotWidgetLibrary.Data);
        }
      })
    );
}
  
    getCustomSnapshotWidgetLibraryByName(snapshotName: string, clientName: string): any | null {
      return this.allCustomSnapshotWidgetLibrary.find(s => s.snapshot_name === snapshotName 
        && s.client_name === clientName) || null;
    }

  saveCustomSnapshotWidgetLibrary(data: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiBaseUrl}Snapshot/addCustomSnapshotWidget`,
      data
    );
  }

  saveCustomMetricSnapshotWidgetLibrary(data: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiBaseUrl}Snapshot/addCustomMetricsSnapshot`,
      data
    );
  }

  updateCustomMetricSnapShotWidgetLibrary(data: any): Observable<any> {
    const formData = new FormData();
    formData.append('customMetricList', JSON.stringify(data));
    return this.http.post<any>(
      `${this.apiBaseUrl}Snapshot/UpdateCustomMetricsSnapshot`,
      formData
    );
  }
  saveCustomSnapshotLayout(data: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiBaseUrl}Snapshot/UpdateLayoutDetails`,
      data
    );
  }

  deleteCustomSnapshotSectionSubsectionLevel(data: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiBaseUrl}Snapshot/DeleteCustomSnapshotWidgetContents`,
      data
    );
  }

  getCustomSnapshotProperties(): Observable<any> {
    return this.http.get<any>(
      `${this.apiBaseUrl}Snapshot/GetChartPropertiesConfiguration`
    );
  }

  getCustomMetrics(data: any): Observable<any> {
    return this.http.post<any>(
      `${this.apiBaseUrl}Snapshot/GetCustomMetricsSnapshot`,
      data
    );
  }

  SampleOutputArray = [
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Awareness',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'UNAWAREfm',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.057570523891767415,
      totalWeightedShare: 0.05630577981113154,
      answerUnweightedShare: 0.057570523891767415,
      answerWeightedShare: 0.05630577981113154,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Unaided Awareness - First Mentions',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 97.80313953193543,
      CurrentNumeratorUnWeighted_Answer: 100,
      CurrentNumeratorUnWeighted_Total: 100,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 97.80313953193543,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 170161,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Awareness',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'UnAwareTotalM_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.14335060449050085,
      totalWeightedShare: 0.14213253891433916,
      answerUnweightedShare: 0.14335060449050085,
      answerWeightedShare: 0.14213253891433916,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Unaided Awareness Total Mentions',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 246.884220094207,
      CurrentNumeratorUnWeighted_Answer: 248.99999999999997,
      CurrentNumeratorUnWeighted_Total: 248.99999999999997,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 246.884220094207,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 180295,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Awareness',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamAwareStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.9303396660909614,
      totalWeightedShare: 0.9287787589015665,
      answerUnweightedShare: 0.9303396660909614,
      answerWeightedShare: 0.9287787589015665,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Aided Brand Awareness',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 1613.28870421202,
      CurrentNumeratorUnWeighted_Answer: 1616,
      CurrentNumeratorUnWeighted_Total: 1616,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 1613.28870421202,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 190439,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.12377662636729994,
      totalWeightedShare: 0.12148150643087761,
      answerUnweightedShare: 0.29411764705882354,
      answerWeightedShare: 0.2840942793254218,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | Retirement Saving/Investing',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 731,
      answerWeightedBase: 742.7582743710392,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 211.0133766704343,
      CurrentNumeratorUnWeighted_Answer: 215,
      CurrentNumeratorUnWeighted_Total: 215,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 742.7582743710392,
      CurrentBaseUnWeighted_Answer: 731,
      CurrentNumeratorWeighted_Total: 211.0133766704343,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 446.3282053732386,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290974,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_10',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.08981001727115717,
      totalWeightedShare: 0.10135843307292795,
      answerUnweightedShare: 0.213406292749658,
      answerWeightedShare: 0.2370348528217493,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | Retirement Income Planning',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 731,
      answerWeightedBase: 742.7582743710392,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 176.05959824767575,
      CurrentNumeratorUnWeighted_Answer: 156,
      CurrentNumeratorUnWeighted_Total: 156,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 742.7582743710392,
      CurrentBaseUnWeighted_Answer: 731,
      CurrentNumeratorWeighted_Total: 176.05959824767575,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 446.3282053732386,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290975,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_11',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.11053540587219343,
      totalWeightedShare: 0.10080448251892382,
      answerUnweightedShare: 0.26265389876880985,
      answerWeightedShare: 0.23573939487061443,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Consider Purpose | Lending (mortgage, line of credit, etc.)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 731,
      answerWeightedBase: 742.7582743710392,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 175.09738613537058,
      CurrentNumeratorUnWeighted_Answer: 192,
      CurrentNumeratorUnWeighted_Total: 192,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 742.7582743710392,
      CurrentBaseUnWeighted_Answer: 731,
      CurrentNumeratorWeighted_Total: 175.09738613537058,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 446.3282053732386,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290976,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_12',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.025906735751295335,
      totalWeightedShare: 0.01916613797369704,
      answerUnweightedShare: 0.06155950752393981,
      answerWeightedShare: 0.04482155609576042,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | Cryptocurrency',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 731,
      answerWeightedBase: 742.7582743710392,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 33.29158166031174,
      CurrentNumeratorUnWeighted_Answer: 45,
      CurrentNumeratorUnWeighted_Total: 45,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 742.7582743710392,
      CurrentBaseUnWeighted_Answer: 731,
      CurrentNumeratorWeighted_Total: 33.29158166031174,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 446.3282053732386,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290977,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_13',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.050662061024755324,
      totalWeightedShare: 0.044056221023868296,
      answerUnweightedShare: 0.12038303693570451,
      answerWeightedShare: 0.10302901840206413,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | Debt Management/Consolidation',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 731,
      answerWeightedBase: 742.7582743710392,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 76.5256559184592,
      CurrentNumeratorUnWeighted_Answer: 88,
      CurrentNumeratorUnWeighted_Total: 88,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 742.7582743710392,
      CurrentBaseUnWeighted_Answer: 731,
      CurrentNumeratorWeighted_Total: 76.5256559184592,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 446.3282053732386,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290978,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_14',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.0955670696603339,
      totalWeightedShare: 0.08469547828086951,
      answerUnweightedShare: 0.2270861833105335,
      answerWeightedShare: 0.19806719204635825,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | Wealth Management',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 731,
      answerWeightedBase: 742.7582743710392,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 147.11604577387027,
      CurrentNumeratorUnWeighted_Answer: 166,
      CurrentNumeratorUnWeighted_Total: 166,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 742.7582743710392,
      CurrentBaseUnWeighted_Answer: 731,
      CurrentNumeratorWeighted_Total: 147.11604577387027,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 446.3282053732386,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290979,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_15',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.03281519861830743,
      totalWeightedShare: 0.03270219277123585,
      answerUnweightedShare: 0.07797537619699042,
      answerWeightedShare: 0.07647670958864443,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | None of these',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 731,
      answerWeightedBase: 742.7582743710392,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 56.80370884363664,
      CurrentNumeratorUnWeighted_Answer: 57,
      CurrentNumeratorUnWeighted_Total: 57.00000000000001,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 742.7582743710392,
      CurrentBaseUnWeighted_Answer: 731,
      CurrentNumeratorWeighted_Total: 56.80370884363664,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 446.3282053732386,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290980,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_2',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.03914795624640184,
      totalWeightedShare: 0.03480111669569952,
      answerUnweightedShare: 0.09302325581395349,
      answerWeightedShare: 0.08138521210230629,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | Educational Savings',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 731,
      answerWeightedBase: 742.7582743710392,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 60.44953970043003,
      CurrentNumeratorUnWeighted_Answer: 68,
      CurrentNumeratorUnWeighted_Total: 68,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 742.7582743710392,
      CurrentBaseUnWeighted_Answer: 731,
      CurrentNumeratorWeighted_Total: 60.44953970043003,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 446.3282053732386,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290981,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_3',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.0846286701208981,
      totalWeightedShare: 0.07637092484295076,
      answerUnweightedShare: 0.20109439124487005,
      answerWeightedShare: 0.1785995538919274,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Consider Purpose | Trading (buying/ selling individual stocks and bonds)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 731,
      answerWeightedBase: 742.7582743710392,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 132.6562964522054,
      CurrentNumeratorUnWeighted_Answer: 147,
      CurrentNumeratorUnWeighted_Total: 147,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 742.7582743710392,
      CurrentBaseUnWeighted_Answer: 731,
      CurrentNumeratorWeighted_Total: 132.6562964522054,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 446.3282053732386,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290982,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_4',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.0535405872193437,
      totalWeightedShare: 0.04696461889433274,
      answerUnweightedShare: 0.12722298221614228,
      answerWeightedShare: 0.10983054088294747,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | Trading mutual funds and ETFs',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 731,
      answerWeightedBase: 742.7582743710392,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 81.57754301945593,
      CurrentNumeratorUnWeighted_Answer: 93.00000000000001,
      CurrentNumeratorUnWeighted_Total: 93,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 742.7582743710392,
      CurrentBaseUnWeighted_Answer: 731,
      CurrentNumeratorWeighted_Total: 81.57754301945593,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 446.3282053732386,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290983,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_5',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.09614277489925158,
      totalWeightedShare: 0.08663893975157026,
      answerUnweightedShare: 0.22845417236662108,
      answerWeightedShare: 0.20261213310065454,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Consider Purpose | Managed Investments Accounts (professional investment management for a fee)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 731,
      answerWeightedBase: 742.7582743710392,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 150.49183834847747,
      CurrentNumeratorUnWeighted_Answer: 167,
      CurrentNumeratorUnWeighted_Total: 167,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 742.7582743710392,
      CurrentBaseUnWeighted_Answer: 731,
      CurrentNumeratorWeighted_Total: 150.49183834847747,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 446.3282053732386,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290984,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_6',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.03223949337938975,
      totalWeightedShare: 0.02920642976634494,
      answerUnweightedShare: 0.07660738714090287,
      answerWeightedShare: 0.06830158647118426,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | Robo-Advised Accounts',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 731,
      answerWeightedBase: 742.7582743710392,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 50.73156850414114,
      CurrentNumeratorUnWeighted_Answer: 56,
      CurrentNumeratorUnWeighted_Total: 55.99999999999999,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 742.7582743710392,
      CurrentBaseUnWeighted_Answer: 731,
      CurrentNumeratorWeighted_Total: 50.73156850414114,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 446.3282053732386,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290985,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_7',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.18825561312607944,
      totalWeightedShare: 0.1767576206291498,
      answerUnweightedShare: 0.4473324213406293,
      answerWeightedShare: 0.4133619208656026,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Consider Purpose | Banking Services (savings/ debit card)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 731,
      answerWeightedBase: 742.7582743710392,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 307.02798703283304,
      CurrentNumeratorUnWeighted_Answer: 327,
      CurrentNumeratorUnWeighted_Total: 327,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 742.7582743710392,
      CurrentBaseUnWeighted_Answer: 731,
      CurrentNumeratorWeighted_Total: 307.02798703283304,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 446.3282053732386,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290986,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_8',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.11859527921704087,
      totalWeightedShare: 0.11399330376171828,
      answerUnweightedShare: 0.2818057455540356,
      answerWeightedShare: 0.26658251475121497,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Consider Purpose | Payment Services (credit card, peer-to-peer payment apps)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 731,
      answerWeightedBase: 742.7582743710392,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 198.00636863410455,
      CurrentNumeratorUnWeighted_Answer: 206.00000000000003,
      CurrentNumeratorUnWeighted_Total: 206,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 742.7582743710392,
      CurrentBaseUnWeighted_Answer: 731,
      CurrentNumeratorWeighted_Total: 198.00636863410455,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 446.3282053732386,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290987,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_9',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.07829591249280368,
      totalWeightedShare: 0.07744137046901862,
      answerUnweightedShare: 0.18604651162790697,
      answerWeightedShare: 0.18110287713535322,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Consider Purpose | Guidance for reaching financial goals',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 731,
      answerWeightedBase: 742.7582743710392,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 134.5156605046853,
      CurrentNumeratorUnWeighted_Answer: 136,
      CurrentNumeratorUnWeighted_Total: 136,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 742.7582743710392,
      CurrentBaseUnWeighted_Answer: 731,
      CurrentNumeratorWeighted_Total: 134.5156605046853,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 446.3282053732386,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290988,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Awareness',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'UNAWAREfm',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.06278026905829596,
      totalWeightedShare: 0.06770813215403948,
      answerUnweightedShare: 0.06278026905829596,
      answerWeightedShare: 0.06770813215403948,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Unaided Awareness - First Mentions',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 105.6923942924556,
      CurrentNumeratorUnWeighted_Answer: 98,
      CurrentNumeratorUnWeighted_Total: 98,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 105.6923942924556,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 170161,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Awareness',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'UnAwareTotalM_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.14862267777065982,
      totalWeightedShare: 0.1456336679502565,
      answerUnweightedShare: 0.14862267777065982,
      answerWeightedShare: 0.1456336679502565,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Unaided Awareness Total Mentions',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 227.33415567035033,
      CurrentNumeratorUnWeighted_Answer: 231.99999999999997,
      CurrentNumeratorUnWeighted_Total: 231.99999999999997,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 227.33415567035033,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 180295,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Awareness',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamAwareStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.931454196028187,
      totalWeightedShare: 0.93023517906652,
      answerUnweightedShare: 0.931454196028187,
      answerWeightedShare: 0.93023517906652,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Aided Brand Awareness',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 1452.0971145228373,
      CurrentNumeratorUnWeighted_Answer: 1454,
      CurrentNumeratorUnWeighted_Total: 1454,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 1452.0971145228373,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 190439,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.12556053811659193,
      totalWeightedShare: 0.125592540319505,
      answerUnweightedShare: 0.28405797101449276,
      answerWeightedShare: 0.28953655492208624,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | Retirement Saving/Investing',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 690,
      answerWeightedBase: 677.1164196918207,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 196.04995543874725,
      CurrentNumeratorUnWeighted_Answer: 196,
      CurrentNumeratorUnWeighted_Total: 196,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 677.1164196918207,
      CurrentBaseUnWeighted_Answer: 690,
      CurrentNumeratorWeighted_Total: 196.04995543874725,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 470.2712682359407,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290974,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_10',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.09865470852017937,
      totalWeightedShare: 0.08983546429652106,
      answerUnweightedShare: 0.22318840579710145,
      answerWeightedShare: 0.2071034694900684,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | Retirement Income Planning',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 690,
      answerWeightedBase: 677.1164196918207,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 140.23315976686933,
      CurrentNumeratorUnWeighted_Answer: 154,
      CurrentNumeratorUnWeighted_Total: 154,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 677.1164196918207,
      CurrentBaseUnWeighted_Answer: 690,
      CurrentNumeratorWeighted_Total: 140.23315976686933,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 470.2712682359407,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290975,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_11',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.1133888532991672,
      totalWeightedShare: 0.11884924102267287,
      answerUnweightedShare: 0.2565217391304348,
      answerWeightedShare: 0.2739907936671076,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Consider Purpose | Lending (mortgage, line of credit, etc.)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 690,
      answerWeightedBase: 677.1164196918207,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 185.5236652363923,
      CurrentNumeratorUnWeighted_Answer: 177,
      CurrentNumeratorUnWeighted_Total: 177,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 677.1164196918207,
      CurrentBaseUnWeighted_Answer: 690,
      CurrentNumeratorWeighted_Total: 185.5236652363923,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 470.2712682359407,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290976,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_12',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.042921204356181936,
      totalWeightedShare: 0.03219437938520581,
      answerUnweightedShare: 0.09710144927536232,
      answerWeightedShare: 0.07421977190152801,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | Cryptocurrency',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 690,
      answerWeightedBase: 677.1164196918207,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 50.25542622030624,
      CurrentNumeratorUnWeighted_Answer: 67,
      CurrentNumeratorUnWeighted_Total: 67,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 677.1164196918207,
      CurrentBaseUnWeighted_Answer: 690,
      CurrentNumeratorWeighted_Total: 50.25542622030625,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 470.2712682359407,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290977,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_13',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.06598334401024984,
      totalWeightedShare: 0.05207174002393069,
      answerUnweightedShare: 0.1492753623188406,
      answerWeightedShare: 0.12004432888269193,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | Debt Management/Consolidation',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 690,
      answerWeightedBase: 677.1164196918207,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 81.28398617735579,
      CurrentNumeratorUnWeighted_Answer: 103,
      CurrentNumeratorUnWeighted_Total: 103,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 677.1164196918207,
      CurrentBaseUnWeighted_Answer: 690,
      CurrentNumeratorWeighted_Total: 81.28398617735579,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 470.2712682359407,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290978,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_14',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.12491992312620115,
      totalWeightedShare: 0.11356780162442312,
      answerUnweightedShare: 0.2826086956521739,
      answerWeightedShare: 0.2618151519887975,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | Wealth Management',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 690,
      answerWeightedBase: 677.1164196918207,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 177.27933833572445,
      CurrentNumeratorUnWeighted_Answer: 194.99999999999997,
      CurrentNumeratorUnWeighted_Total: 195,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 677.1164196918207,
      CurrentBaseUnWeighted_Answer: 690,
      CurrentNumeratorWeighted_Total: 177.27933833572445,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 470.2712682359407,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290979,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_15',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.03139013452914798,
      totalWeightedShare: 0.03371833980585227,
      answerUnweightedShare: 0.07101449275362319,
      answerWeightedShare: 0.0777330558028575,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | None of these',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 690,
      answerWeightedBase: 677.1164196918207,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 52.63432843693538,
      CurrentNumeratorUnWeighted_Answer: 49,
      CurrentNumeratorUnWeighted_Total: 49,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 677.1164196918207,
      CurrentBaseUnWeighted_Answer: 690,
      CurrentNumeratorWeighted_Total: 52.63432843693537,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 470.2712682359407,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290980,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_2',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.048046124279308135,
      totalWeightedShare: 0.04497864864054214,
      answerUnweightedShare: 0.10869565217391304,
      answerWeightedShare: 0.10369216944974108,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | Educational Savings',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 690,
      answerWeightedBase: 677.1164196918207,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 70.21167052788627,
      CurrentNumeratorUnWeighted_Answer: 75,
      CurrentNumeratorUnWeighted_Total: 75,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 677.1164196918207,
      CurrentBaseUnWeighted_Answer: 690,
      CurrentNumeratorWeighted_Total: 70.21167052788627,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 470.2712682359407,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290981,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_3',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.09160794362588084,
      totalWeightedShare: 0.08016766075846295,
      answerUnweightedShare: 0.2072463768115942,
      answerWeightedShare: 0.18481566065244287,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Consider Purpose | Trading (buying/ selling individual stocks and bonds)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 690,
      answerWeightedBase: 677.1164196918207,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 125.14171844396063,
      CurrentNumeratorUnWeighted_Answer: 143,
      CurrentNumeratorUnWeighted_Total: 143,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 677.1164196918207,
      CurrentBaseUnWeighted_Answer: 690,
      CurrentNumeratorWeighted_Total: 125.14171844396063,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 470.2712682359407,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290982,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_4',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.07623318385650224,
      totalWeightedShare: 0.0668277293127055,
      answerUnweightedShare: 0.17246376811594202,
      answerWeightedShare: 0.15406225934472545,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | Trading mutual funds and ETFs',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 690,
      answerWeightedBase: 677.1164196918207,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 104.31808545713325,
      CurrentNumeratorUnWeighted_Answer: 119,
      CurrentNumeratorUnWeighted_Total: 119,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 677.1164196918207,
      CurrentBaseUnWeighted_Answer: 690,
      CurrentNumeratorWeighted_Total: 104.31808545713326,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 470.2712682359407,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290983,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_5',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.0954516335682255,
      totalWeightedShare: 0.0853487280418548,
      answerUnweightedShare: 0.21594202898550724,
      answerWeightedShare: 0.19675990804354238,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Consider Purpose | Managed Investments Accounts (professional investment management for a fee)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 690,
      answerWeightedBase: 677.1164196918207,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 133.2293644733353,
      CurrentNumeratorUnWeighted_Answer: 149,
      CurrentNumeratorUnWeighted_Total: 149,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 677.1164196918207,
      CurrentBaseUnWeighted_Answer: 690,
      CurrentNumeratorWeighted_Total: 133.2293644733353,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 470.2712682359407,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290984,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_6',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.033952594490711085,
      totalWeightedShare: 0.026310245900298124,
      answerUnweightedShare: 0.07681159420289856,
      answerWeightedShare: 0.06065470081061966,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Consider Purpose | Robo-Advised Accounts',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 690,
      answerWeightedBase: 677.1164196918207,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 41.07029385036536,
      CurrentNumeratorUnWeighted_Answer: 53.00000000000001,
      CurrentNumeratorUnWeighted_Total: 53.00000000000001,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 677.1164196918207,
      CurrentBaseUnWeighted_Answer: 690,
      CurrentNumeratorWeighted_Total: 41.07029385036536,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 470.2712682359407,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290985,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_7',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.19538757206918642,
      totalWeightedShare: 0.1874256730120543,
      answerUnweightedShare: 0.4420289855072464,
      answerWeightedShare: 0.43208444967997695,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Consider Purpose | Banking Services (savings/ debit card)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 690,
      answerWeightedBase: 677.1164196918207,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 292.5714755718167,
      CurrentNumeratorUnWeighted_Answer: 305,
      CurrentNumeratorUnWeighted_Total: 305,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 677.1164196918207,
      CurrentBaseUnWeighted_Answer: 690,
      CurrentNumeratorWeighted_Total: 292.5714755718167,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 470.2712682359407,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290986,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_8',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.12556053811659193,
      totalWeightedShare: 0.11672151908407355,
      answerUnweightedShare: 0.28405797101449276,
      answerWeightedShare: 0.2690856195352128,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Consider Purpose | Payment Services (credit card, peer-to-peer payment apps)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 690,
      answerWeightedBase: 677.1164196918207,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 182.20229129023875,
      CurrentNumeratorUnWeighted_Answer: 196,
      CurrentNumeratorUnWeighted_Total: 196,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 677.1164196918207,
      CurrentBaseUnWeighted_Answer: 690,
      CurrentNumeratorWeighted_Total: 182.20229129023875,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 470.2712682359407,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290987,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 1,
      widgetName: 'Consider Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandConsiderPurpose_1_9',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.08456117873158232,
      totalWeightedShare: 0.07513948575587714,
      answerUnweightedShare: 0.19130434782608696,
      answerWeightedShare: 0.17322388566253968,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Consider Purpose | Guidance for reaching financial goals',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 690,
      answerWeightedBase: 677.1164196918207,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 117.29273726492418,
      CurrentNumeratorUnWeighted_Answer: 132,
      CurrentNumeratorUnWeighted_Total: 132,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 677.1164196918207,
      CurrentBaseUnWeighted_Answer: 690,
      CurrentNumeratorWeighted_Total: 117.29273726492418,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 470.2712682359407,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 290988,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Consideration',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'UNCONSfm',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.06332757628094415,
      totalWeightedShare: 0.06790849613709798,
      answerUnweightedShare: 0.06332757628094415,
      answerWeightedShare: 0.06790849613709798,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Unaided Consideration - First Mentions',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 117.95705779013913,
      CurrentNumeratorUnWeighted_Answer: 110,
      CurrentNumeratorUnWeighted_Total: 110,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 117.95705779013913,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 250476,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Consideration',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'UnConstTotalM_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.10765687967760507,
      totalWeightedShare: 0.11173433695448479,
      answerUnweightedShare: 0.10765687967760507,
      answerWeightedShare: 0.11173433695448479,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Unaided Consideration Total Mentions',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 194.08254328993996,
      CurrentNumeratorUnWeighted_Answer: 187,
      CurrentNumeratorUnWeighted_Total: 187,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 194.08254328993996,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 260609,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Consideration',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'ConsiderationTotal_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.7230857800805988,
      totalWeightedShare: 0.7297138099034183,
      answerUnweightedShare: 0.7772277227722773,
      answerWeightedShare: 0.7856702179175855,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1|2|3',
      colResponseCode: '',
      rowChild: 'Aided Consideration | Overall Consideration (Top3Box)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: true,
      CalculationType: 'RespGrp',
      CurrentNumeratorWeighted_Answer: 1267.512887802237,
      CurrentNumeratorUnWeighted_Answer: 1256,
      CurrentNumeratorUnWeighted_Total: 1256,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 1267.512887802237,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 280877,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Consideration',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'ConsiderationTotal_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.4208405296488198,
      totalWeightedShare: 0.42760982980485873,
      answerUnweightedShare: 0.45235148514851486,
      answerWeightedShare: 0.46040009604717663,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1|2',
      colResponseCode: '',
      rowChild: 'Aided Consideration | Serious Consideration (Top2Box)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: true,
      CalculationType: 'RespGrp',
      CurrentNumeratorWeighted_Answer: 742.7582743710392,
      CurrentNumeratorUnWeighted_Answer: 731,
      CurrentNumeratorUnWeighted_Total: 731,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 742.7582743710392,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 280878,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.1047783534830167,
      totalWeightedShare: 0.09960375615248611,
      answerUnweightedShare: 0.4108352144469526,
      answerWeightedShare: 0.41144811382589985,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Checking (including high yield)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 173.0117244368683,
      CurrentNumeratorUnWeighted_Answer: 182,
      CurrentNumeratorUnWeighted_Total: 182,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 173.0117244368683,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451348,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_10',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.016119746689694875,
      totalWeightedShare: 0.012835564696101864,
      answerUnweightedShare: 0.06320541760722348,
      answerWeightedShare: 0.053021784399539466,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Use Purpose | Individual retirement accounts (e.g., Roth IRA, SEP IRA, Simple IRA)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 22.295375877128926,
      CurrentNumeratorUnWeighted_Answer: 28,
      CurrentNumeratorUnWeighted_Total: 27.999999999999996,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 22.295375877128926,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451349,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_11',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.004605641911341394,
      totalWeightedShare: 0.004109290055780529,
      answerUnweightedShare: 0.01805869074492099,
      answerWeightedShare: 0.01697485825761426,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Use Purpose | Annuities that provide guaranteed lifetime income',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 7.137836826890777,
      CurrentNumeratorUnWeighted_Answer: 7.999999999999999,
      CurrentNumeratorUnWeighted_Total: 8,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 7.1378368268907755,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451350,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_12',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.021876799078871616,
      totalWeightedShare: 0.017657615584241466,
      answerUnweightedShare: 0.08577878103837472,
      answerWeightedShare: 0.07294095029585514,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Use Purpose | Brokerage account for investing or trading (e.g., mutual funds, individual stocks, ETFs)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 30.671278269827404,
      CurrentNumeratorUnWeighted_Answer: 38,
      CurrentNumeratorUnWeighted_Total: 38,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 30.67127826982741,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451351,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_13',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.01957397812320092,
      totalWeightedShare: 0.017283965555126644,
      answerUnweightedShare: 0.07674943566591422,
      answerWeightedShare: 0.07139745830670842,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Personal loan or a car loan',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 30.02224816925496,
      CurrentNumeratorUnWeighted_Answer: 34,
      CurrentNumeratorUnWeighted_Total: 34,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 30.022248169254965,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451352,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_14',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.02072538860103627,
      totalWeightedShare: 0.02072413640847196,
      answerUnweightedShare: 0.08126410835214447,
      answerWeightedShare: 0.08560828592530559,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Mortgage or home equity loan/line',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 35.99782494151577,
      CurrentNumeratorUnWeighted_Answer: 36,
      CurrentNumeratorUnWeighted_Total: 36,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 35.99782494151577,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451353,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_15',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.008059873344847437,
      totalWeightedShare: 0.0029651716929171255,
      answerUnweightedShare: 0.03160270880361174,
      answerWeightedShare: 0.012248677633732491,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | NFT (non-fungible token)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 5.150503230597044,
      CurrentNumeratorUnWeighted_Answer: 14,
      CurrentNumeratorUnWeighted_Total: 13.999999999999998,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 5.150503230597044,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451354,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_16',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.004029936672423719,
      totalWeightedShare: 0.0017814965642494011,
      answerUnweightedShare: 0.01580135440180587,
      answerWeightedShare: 0.007359093968560558,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Student loan(s)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 3.094459532101208,
      CurrentNumeratorUnWeighted_Answer: 7,
      CurrentNumeratorUnWeighted_Total: 6.999999999999999,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 3.094459532101208,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451355,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_17',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.0057570523891767415,
      totalWeightedShare: 0.003311175868181143,
      answerUnweightedShare: 0.022573363431151242,
      answerWeightedShare: 0.013677968764785008,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Employer issued company shares / equity',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 5.751512483030642,
      CurrentNumeratorUnWeighted_Answer: 10,
      CurrentNumeratorUnWeighted_Total: 10,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 5.751512483030642,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451356,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_18',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.0034542314335060447,
      totalWeightedShare: 0.0028887608377410534,
      answerUnweightedShare: 0.013544018058690745,
      answerWeightedShare: 0.0119330359004038,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Robo-advised account',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 5.017777575156207,
      CurrentNumeratorUnWeighted_Answer: 6,
      CurrentNumeratorUnWeighted_Total: 6,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 5.017777575156207,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451357,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_19',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.018422567645365574,
      totalWeightedShare: 0.013620545303044573,
      answerUnweightedShare: 0.07223476297968397,
      answerWeightedShare: 0.05626442104892477,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Use Purpose | Managed investment account (e.g., account where you pay a fee and give permission to have investments managed on your behalf)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 23.658887191388413,
      CurrentNumeratorUnWeighted_Answer: 31.999999999999996,
      CurrentNumeratorUnWeighted_Total: 32,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 23.658887191388413,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451358,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_20',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.009211283822682787,
      totalWeightedShare: 0.006156429710058995,
      answerUnweightedShare: 0.03611738148984198,
      answerWeightedShare: 0.02543128381852977,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | 529 Education Savings',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 10.693718406372469,
      CurrentNumeratorUnWeighted_Answer: 15.999999999999998,
      CurrentNumeratorUnWeighted_Total: 16,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 10.693718406372469,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451359,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_21',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.014392630972941854,
      totalWeightedShare: 0.008568224530032385,
      answerUnweightedShare: 0.056433408577878104,
      answerWeightedShare: 0.03539404494265791,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Health Savings Account',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 14.883006008666248,
      CurrentNumeratorUnWeighted_Answer: 25,
      CurrentNumeratorUnWeighted_Total: 25,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 14.883006008666246,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451360,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_22',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.015544041450777202,
      totalWeightedShare: 0.010268436288568512,
      answerUnweightedShare: 0.060948081264108354,
      answerWeightedShare: 0.04241736362236058,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Wealth Management',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 17.836273833243496,
      CurrentNumeratorUnWeighted_Answer: 27,
      CurrentNumeratorUnWeighted_Total: 27,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 17.836273833243496,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451361,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_23',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.016119746689694875,
      totalWeightedShare: 0.016342867578073742,
      answerUnweightedShare: 0.06320541760722348,
      answerWeightedShare: 0.0675099243166148,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Another product/purpose',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 28.387560983114074,
      CurrentNumeratorUnWeighted_Answer: 28,
      CurrentNumeratorUnWeighted_Total: 27.999999999999996,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 28.387560983114074,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451362,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_24',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.1047783534830167,
      totalWeightedShare: 0.09960375615248611,
      answerUnweightedShare: 0.4108352144469526,
      answerWeightedShare: 0.41144811382589985,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Banking(Checking/ Saving)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 173.0117244368683,
      CurrentNumeratorUnWeighted_Answer: 182,
      CurrentNumeratorUnWeighted_Total: 182,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 173.0117244368683,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451363,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_25',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Other',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451364,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_3',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.02072538860103627,
      totalWeightedShare: 0.017374220582835713,
      answerUnweightedShare: 0.08126410835214447,
      answerWeightedShare: 0.07177028823148907,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Use Purpose | Money market or CD’s (Certificate of Deposit)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 30.179021152385616,
      CurrentNumeratorUnWeighted_Answer: 36,
      CurrentNumeratorUnWeighted_Total: 36,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 30.17902115238562,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451365,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_4',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.00978698906160046,
      totalWeightedShare: 0.007548699183713402,
      answerUnweightedShare: 0.03837471783295711,
      answerWeightedShare: 0.03118253930326769,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Cash Management Account',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 13.112090482110172,
      CurrentNumeratorUnWeighted_Answer: 17,
      CurrentNumeratorUnWeighted_Total: 17,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 13.112090482110172,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451366,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_5',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.14277489925158318,
      totalWeightedShare: 0.1314945365926815,
      answerUnweightedShare: 0.5598194130925508,
      answerWeightedShare: 0.5431841242677791,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Credit card(s)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 228.40601006148768,
      CurrentNumeratorUnWeighted_Answer: 248,
      CurrentNumeratorUnWeighted_Total: 248,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 228.40601006148768,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451367,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_6',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.008635578583765112,
      totalWeightedShare: 0.004788321995228209,
      answerUnweightedShare: 0.033860045146726865,
      answerWeightedShare: 0.019779836920121422,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Cryptocurrency',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 8.317315305711395,
      CurrentNumeratorUnWeighted_Answer: 15.000000000000002,
      CurrentNumeratorUnWeighted_Total: 15,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 8.317315305711395,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451368,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_7',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.07656879677605066,
      totalWeightedShare: 0.0732658638655774,
      answerUnweightedShare: 0.3002257336343115,
      answerWeightedShare: 0.302650247940118,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Debit card(s)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 127.26280553450789,
      CurrentNumeratorUnWeighted_Answer: 133,
      CurrentNumeratorUnWeighted_Total: 133,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 127.26280553450788,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451369,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_8',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.00978698906160046,
      totalWeightedShare: 0.008016395867996245,
      answerUnweightedShare: 0.03837471783295711,
      answerWeightedShare: 0.033114523859113176,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Use Purpose | Peer-to-peer payment apps (e.g., PayPal, Venmo or Zelle)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 13.92447962270947,
      CurrentNumeratorUnWeighted_Answer: 17,
      CurrentNumeratorUnWeighted_Total: 17,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 13.924479622709471,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451370,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_9',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.016119746689694875,
      totalWeightedShare: 0.01319244184278889,
      answerUnweightedShare: 0.06320541760722348,
      answerWeightedShare: 0.05449599013779647,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Use Purpose | Employer sponsored retirement accounts (e.g., 401(k) or 403(b))',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 443,
      answerWeightedBase: 420.4946349810622,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 22.91527148092429,
      CurrentNumeratorUnWeighted_Answer: 28,
      CurrentNumeratorUnWeighted_Total: 27.999999999999996,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 420.4946349810622,
      CurrentBaseUnWeighted_Answer: 443,
      CurrentNumeratorWeighted_Total: 22.91527148092429,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 267.9473170366817,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451371,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Consideration',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'UNCONSfm',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.07687379884689302,
      totalWeightedShare: 0.0811419143918758,
      answerUnweightedShare: 0.07687379884689302,
      answerWeightedShare: 0.0811419143918758,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Unaided Consideration - First Mentions',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 126.66252836571809,
      CurrentNumeratorUnWeighted_Answer: 120,
      CurrentNumeratorUnWeighted_Total: 120,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 126.66252836571809,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 250476,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Consideration',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'UnConstTotalM_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.12235746316463805,
      totalWeightedShare: 0.12470347569659147,
      answerUnweightedShare: 0.12235746316463805,
      answerWeightedShare: 0.12470347569659147,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Unaided Consideration Total Mentions',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 194.66212556237923,
      CurrentNumeratorUnWeighted_Answer: 191,
      CurrentNumeratorUnWeighted_Total: 191,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 194.66212556237923,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 260609,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Consideration',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'ConsiderationTotal_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.7501601537475977,
      totalWeightedShare: 0.7355816513429256,
      answerUnweightedShare: 0.8053645116918845,
      answerWeightedShare: 0.7907480472637823,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1|2|3',
      colResponseCode: '',
      rowChild: 'Aided Consideration | Overall Consideration (Top3Box)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: true,
      CalculationType: 'RespGrp',
      CurrentNumeratorWeighted_Answer: 1148.2429577463065,
      CurrentNumeratorUnWeighted_Answer: 1171,
      CurrentNumeratorUnWeighted_Total: 1171,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 1148.2429577463065,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 280877,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Consideration',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'ConsiderationTotal_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.44202434336963486,
      totalWeightedShare: 0.43377092869431194,
      answerUnweightedShare: 0.47455295735900965,
      answerWeightedShare: 0.46630243454090387,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1|2',
      colResponseCode: '',
      rowChild: 'Aided Consideration | Serious Consideration (Top2Box)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: true,
      CalculationType: 'RespGrp',
      CurrentNumeratorWeighted_Answer: 677.1164196918207,
      CurrentNumeratorUnWeighted_Answer: 690,
      CurrentNumeratorUnWeighted_Total: 690,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 677.1164196918207,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 280878,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.1133888532991672,
      totalWeightedShare: 0.1072590686483942,
      answerUnweightedShare: 0.42042755344418054,
      answerWeightedShare: 0.43300032278272743,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Checking (including high yield)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 167.4314061601433,
      CurrentNumeratorUnWeighted_Answer: 177,
      CurrentNumeratorUnWeighted_Total: 177,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 167.4314061601433,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451348,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_10',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.02626521460602178,
      totalWeightedShare: 0.017760504630613228,
      answerUnweightedShare: 0.09738717339667459,
      answerWeightedShare: 0.07169840587604977,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Use Purpose | Individual retirement accounts (e.g., Roth IRA, SEP IRA, Simple IRA)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 27.72414772838724,
      CurrentNumeratorUnWeighted_Answer: 41,
      CurrentNumeratorUnWeighted_Total: 41,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 27.72414772838724,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451349,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_11',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.0064061499039077515,
      totalWeightedShare: 0.0015954086787307595,
      answerUnweightedShare: 0.023752969121140142,
      answerWeightedShare: 0.006440597345902144,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Use Purpose | Annuities that provide guaranteed lifetime income',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 2.490432947498715,
      CurrentNumeratorUnWeighted_Answer: 10,
      CurrentNumeratorUnWeighted_Total: 10,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 2.490432947498715,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451350,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_12',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.02242152466367713,
      totalWeightedShare: 0.00941939608733879,
      answerUnweightedShare: 0.0831353919239905,
      answerWeightedShare: 0.038025703538468285,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Use Purpose | Brokerage account for investing or trading (e.g., mutual funds, individual stocks, ETFs)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 14.703677292335849,
      CurrentNumeratorUnWeighted_Answer: 35,
      CurrentNumeratorUnWeighted_Total: 35,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 14.703677292335849,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451351,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_13',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.008968609865470852,
      totalWeightedShare: 0.007013759297989246,
      answerUnweightedShare: 0.0332541567695962,
      answerWeightedShare: 0.028314249584854716,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Personal loan or a car loan',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 10.94847826416121,
      CurrentNumeratorUnWeighted_Answer: 14,
      CurrentNumeratorUnWeighted_Total: 14,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 10.94847826416121,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451352,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_14',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.017937219730941704,
      totalWeightedShare: 0.01376548530018205,
      answerUnweightedShare: 0.0665083135391924,
      answerWeightedShare: 0.05557068183930154,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Mortgage or home equity loan/line',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 21.487922553584173,
      CurrentNumeratorUnWeighted_Answer: 28,
      CurrentNumeratorUnWeighted_Total: 28,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 21.487922553584173,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451353,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_15',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.004484304932735426,
      totalWeightedShare: 0.0021273429682131064,
      answerUnweightedShare: 0.0166270783847981,
      answerWeightedShare: 0.008587993570272635,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | NFT (non-fungible token)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 3.3207823733806583,
      CurrentNumeratorUnWeighted_Answer: 7,
      CurrentNumeratorUnWeighted_Total: 7,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 3.3207823733806583,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451354,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_16',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.004484304932735426,
      totalWeightedShare: 0.0016537130385890764,
      answerUnweightedShare: 0.0166270783847981,
      answerWeightedShare: 0.006675969580216891,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Student loan(s)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 2.5814460532375474,
      CurrentNumeratorUnWeighted_Answer: 7,
      CurrentNumeratorUnWeighted_Total: 7,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 2.5814460532375474,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451355,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_17',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.0064061499039077515,
      totalWeightedShare: 0.0015381247523186842,
      answerUnweightedShare: 0.023752969121140142,
      answerWeightedShare: 0.006209344558242758,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Employer issued company shares / equity',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 2.4010127383694653,
      CurrentNumeratorUnWeighted_Answer: 10,
      CurrentNumeratorUnWeighted_Total: 10,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 2.4010127383694653,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451356,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_18',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.0064061499039077515,
      totalWeightedShare: 0.0038072629146205083,
      answerUnweightedShare: 0.023752969121140142,
      answerWeightedShare: 0.015369759328728503,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Robo-advised account',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 5.9431374097226115,
      CurrentNumeratorUnWeighted_Answer: 10,
      CurrentNumeratorUnWeighted_Total: 10,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 5.9431374097226115,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451357,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_19',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.016655989750160152,
      totalWeightedShare: 0.011108329619229432,
      answerUnweightedShare: 0.06175771971496437,
      answerWeightedShare: 0.04484385676022076,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Use Purpose | Managed investment account (e.g., account where you pay a fee and give permission to have investments managed on your behalf)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 17.340102535617138,
      CurrentNumeratorUnWeighted_Answer: 26,
      CurrentNumeratorUnWeighted_Total: 25.999999999999996,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 17.340102535617138,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451358,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_20',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.005765534913516977,
      totalWeightedShare: 0.006417696007912083,
      answerUnweightedShare: 0.021377672209026127,
      answerWeightedShare: 0.025907967297914402,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | 529 Education Savings',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 10.018023468350759,
      CurrentNumeratorUnWeighted_Answer: 9,
      CurrentNumeratorUnWeighted_Total: 9,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 10.018023468350759,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451359,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_21',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.014734144778987828,
      totalWeightedShare: 0.007778191745045393,
      answerUnweightedShare: 0.05463182897862233,
      answerWeightedShare: 0.03140023103604511,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Health Savings Account',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 12.141757314015855,
      CurrentNumeratorUnWeighted_Answer: 23,
      CurrentNumeratorUnWeighted_Total: 23,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 12.141757314015855,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451360,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_22',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.013452914798206279,
      totalWeightedShare: 0.0040526493243233565,
      answerUnweightedShare: 0.0498812351543943,
      answerWeightedShare: 0.016360373884185195,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Wealth Management',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 6.326185595268758,
      CurrentNumeratorUnWeighted_Answer: 21,
      CurrentNumeratorUnWeighted_Total: 21,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 6.326185595268758,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451361,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_23',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.016015374759769378,
      totalWeightedShare: 0.0163268752871308,
      answerUnweightedShare: 0.05938242280285035,
      answerWeightedShare: 0.06591090486283847,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Another product/purpose',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 25.48625232321117,
      CurrentNumeratorUnWeighted_Answer: 25,
      CurrentNumeratorUnWeighted_Total: 25,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 25.486252323211172,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451362,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_24',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.1133888532991672,
      totalWeightedShare: 0.1072590686483942,
      answerUnweightedShare: 0.42042755344418054,
      answerWeightedShare: 0.43300032278272743,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Banking(Checking/ Saving)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 167.4314061601433,
      CurrentNumeratorUnWeighted_Answer: 177,
      CurrentNumeratorUnWeighted_Total: 177,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 167.4314061601433,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451363,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_25',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Other',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451364,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_3',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.02114029468289558,
      totalWeightedShare: 0.015194971344573123,
      answerUnweightedShare: 0.07838479809976247,
      answerWeightedShare: 0.061341456529353876,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Use Purpose | Money market or CD’s (Certificate of Deposit)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 23.71935026887864,
      CurrentNumeratorUnWeighted_Answer: 33,
      CurrentNumeratorUnWeighted_Total: 33,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 23.71935026887864,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451365,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_4',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.012812299807815503,
      totalWeightedShare: 0.00908481630888159,
      answerUnweightedShare: 0.047505938242280284,
      answerWeightedShare: 0.03667501912647278,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Cash Management Account',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 14.181398258164156,
      CurrentNumeratorUnWeighted_Answer: 20,
      CurrentNumeratorUnWeighted_Total: 20,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 14.181398258164156,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451366,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_5',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.14285714285714285,
      totalWeightedShare: 0.1351520104247536,
      answerUnweightedShare: 0.5296912114014252,
      answerWeightedShare: 0.5456029487864565,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Credit card(s)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 210.9722882730403,
      CurrentNumeratorUnWeighted_Answer: 223,
      CurrentNumeratorUnWeighted_Total: 223,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 210.97228827304033,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451367,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_6',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.009609224855861628,
      totalWeightedShare: 0.006504848587942213,
      answerUnweightedShare: 0.035629453681710214,
      answerWeightedShare: 0.02625979857670445,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Cryptocurrency',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 10.154068645777791,
      CurrentNumeratorUnWeighted_Answer: 15,
      CurrentNumeratorUnWeighted_Total: 15,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 10.154068645777791,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451368,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_7',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.07174887892376682,
      totalWeightedShare: 0.06566385064158752,
      answerUnweightedShare: 0.2660332541567696,
      answerWeightedShare: 0.2650821872803001,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Debit card(s)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 102.50127085151807,
      CurrentNumeratorUnWeighted_Answer: 112,
      CurrentNumeratorUnWeighted_Total: 112,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 102.50127085151809,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451369,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_8',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.008968609865470852,
      totalWeightedShare: 0.0086705125190614,
      answerUnweightedShare: 0.0332541567695962,
      answerWeightedShare: 0.03500249225314779,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Use Purpose | Peer-to-peer payment apps (e.g., PayPal, Venmo or Zelle)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 13.534670042254842,
      CurrentNumeratorUnWeighted_Answer: 14,
      CurrentNumeratorUnWeighted_Total: 14,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 13.534670042254842,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451370,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_1_9',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.01985906470211403,
      totalWeightedShare: 0.013107560953484547,
      answerUnweightedShare: 0.07363420427553444,
      answerWeightedShare: 0.052914669083676154,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Brand Use Purpose | Employer sponsored retirement accounts (e.g., 401(k) or 403(b))',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 421,
      answerWeightedBase: 386.677324127903,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 20.46090264838937,
      CurrentNumeratorUnWeighted_Answer: 30.999999999999996,
      CurrentNumeratorUnWeighted_Total: 31,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 386.677324127903,
      CurrentBaseUnWeighted_Answer: 421,
      CurrentNumeratorWeighted_Total: 20.46090264838937,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 247.37052173923456,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 451371,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_23_2',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: null,
      totalWeightedShare: null,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Savings (including high yield)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: null,
      totalWeightedBase: null,
      answerUnweightedBase: null,
      answerWeightedBase: null,
      isDerived: null,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: null,
      CurrentBaseUnWeighted_Total: null,
      CurrentBaseWeighted_Answer: null,
      CurrentBaseUnWeighted_Answer: null,
      CurrentNumeratorWeighted_Total: null,
      CurrentBaseWeighted_Total: null,
      TotalEbaseE1: null,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 0,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: null,
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 2,
      widgetName: 'Use Purpose',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'BrandUsePurpose_23_2',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: null,
      totalWeightedShare: null,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Brand Use Purpose | Savings (including high yield)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: null,
      totalWeightedBase: null,
      answerUnweightedBase: null,
      answerWeightedBase: null,
      isDerived: null,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: null,
      CurrentBaseUnWeighted_Total: null,
      CurrentBaseWeighted_Answer: null,
      CurrentBaseUnWeighted_Answer: null,
      CurrentNumeratorWeighted_Total: null,
      CurrentBaseWeighted_Total: null,
      TotalEbaseE1: null,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 0,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: null,
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Familiarity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.08175014392630973,
      totalWeightedShare: 0.08126428420077486,
      answerUnweightedShare: 0.08175014392630973,
      answerWeightedShare: 0.08126428420077486,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Familiarity | Do business with most often/Primary Provider(s)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 141.15606165674586,
      CurrentNumeratorUnWeighted_Answer: 142,
      CurrentNumeratorUnWeighted_Total: 142,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 141.15606165674586,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 270748,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Familiarity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.1732872769142199,
      totalWeightedShare: 0.16081668009459782,
      answerUnweightedShare: 0.1732872769142199,
      answerWeightedShare: 0.16081668009459782,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '2',
      colResponseCode: '',
      rowChild: 'Familiarity | Do business with currently',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 279.33857332431626,
      CurrentNumeratorUnWeighted_Answer: 301,
      CurrentNumeratorUnWeighted_Total: 301,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 279.33857332431626,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 270749,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Familiarity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.1203223949337939,
      totalWeightedShare: 0.12706741630810195,
      answerUnweightedShare: 0.1203223949337939,
      answerWeightedShare: 0.12706741630810195,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '3',
      colResponseCode: '',
      rowChild:
        'Familiarity | Have done business with in the past, but not currently',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 220.71610212717297,
      CurrentNumeratorUnWeighted_Answer: 209,
      CurrentNumeratorUnWeighted_Total: 209,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 220.71610212717297,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 270750,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Familiarity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.27000575705238916,
      totalWeightedShare: 0.27283843648278555,
      answerUnweightedShare: 0.27000575705238916,
      answerWeightedShare: 0.27283843648278555,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '4',
      colResponseCode: '',
      rowChild: 'Familiarity | Heard a lot about, but never did business with',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 473.92036417059825,
      CurrentNumeratorUnWeighted_Answer: 469,
      CurrentNumeratorUnWeighted_Total: 469,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 473.92036417059825,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 270751,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Familiarity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.2849740932642487,
      totalWeightedShare: 0.2867919418153062,
      answerUnweightedShare: 0.2849740932642487,
      answerWeightedShare: 0.2867919418153062,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '5',
      colResponseCode: '',
      rowChild:
        'Familiarity | Heard a little about, but never did business with',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 498.15760293318664,
      CurrentNumeratorUnWeighted_Answer: 495,
      CurrentNumeratorUnWeighted_Total: 495,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 498.15760293318664,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 270752,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Familiarity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.06966033390903857,
      totalWeightedShare: 0.07122124109843353,
      answerUnweightedShare: 0.06966033390903857,
      answerWeightedShare: 0.07122124109843353,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '6',
      colResponseCode: '',
      rowChild: 'Familiarity | Never heard of them',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 123.71129578797898,
      CurrentNumeratorUnWeighted_Answer: 121,
      CurrentNumeratorUnWeighted_Total: 121,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 123.71129578797898,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 270753,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_19',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.1807714450201497,
      totalWeightedShare: 0.18098825700476298,
      answerUnweightedShare: 0.1943069306930693,
      answerWeightedShare: 0.19486692096491456,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Is A Brand For Me In The Future',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 314.37660241727315,
      CurrentNumeratorUnWeighted_Answer: 314,
      CurrentNumeratorUnWeighted_Total: 314,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 314.37660241727315,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651876,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_2',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.1888313183649971,
      totalWeightedShare: 0.18989206635757683,
      answerUnweightedShare: 0.20297029702970298,
      answerWeightedShare: 0.20445349824984738,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Provides A Personalized Experience',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 329.8425192631108,
      CurrentNumeratorUnWeighted_Answer: 328,
      CurrentNumeratorUnWeighted_Total: 328,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 329.8425192631108,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651877,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_20',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.3857225100748417,
      totalWeightedShare: 0.3837603873881979,
      answerUnweightedShare: 0.4146039603960396,
      answerWeightedShare: 0.4131881610234687,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | No answer',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 666.5917928932994,
      CurrentNumeratorUnWeighted_Answer: 670,
      CurrentNumeratorUnWeighted_Total: 670,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 666.5917928932994,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651878,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_21',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has An Easy To Navigate Website',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651879,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_22',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has An Easy To Use App',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651880,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_23',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Is A Brand For Me',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651881,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_24',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has Best-in-class Online Security',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651882,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_25',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Provides Educational Resources',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651883,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_26',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Shares Meaningful Insights Related To Your Finances',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651884,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_27',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has Expert Financial Advisors',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651885,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_28',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Understands And Respects Your Culture',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651886,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_29',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Helps You Realize Your Financial Possibilities',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651887,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_3',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.21473805411629246,
      totalWeightedShare: 0.21925022405742842,
      answerUnweightedShare: 0.23081683168316833,
      answerWeightedShare: 0.2360629180589012,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Is Easy To Do Business With',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 380.837639187753,
      CurrentNumeratorUnWeighted_Answer: 373,
      CurrentNumeratorUnWeighted_Total: 373,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 380.837639187753,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651888,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_30',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Looks Out For Your Best Interest',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651889,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_4',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.19573978123200922,
      totalWeightedShare: 0.19974439656069223,
      answerUnweightedShare: 0.2103960396039604,
      answerWeightedShare: 0.21506133150258822,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has Excellent Customer Service',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 346.95601682592223,
      CurrentNumeratorUnWeighted_Answer: 340,
      CurrentNumeratorUnWeighted_Total: 340,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 346.95601682592223,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651890,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_5',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.15083477259643063,
      totalWeightedShare: 0.141505692867751,
      answerUnweightedShare: 0.16212871287128713,
      answerWeightedShare: 0.15235672813523937,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has A Positive Impact On The World Around Me',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 245.79538851128336,
      CurrentNumeratorUnWeighted_Answer: 262,
      CurrentNumeratorUnWeighted_Total: 262,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 245.79538851128336,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651891,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_6',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.11226252158894647,
      totalWeightedShare: 0.1036694094409976,
      answerUnweightedShare: 0.12066831683168316,
      answerWeightedShare: 0.11161905722693714,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Helps Less Experienced Investors Get Started',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 180.07376419901274,
      CurrentNumeratorUnWeighted_Answer: 195,
      CurrentNumeratorUnWeighted_Total: 195,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 180.07376419901274,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651892,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_7',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.23200921128382268,
      totalWeightedShare: 0.22522807594320057,
      answerUnweightedShare: 0.24938118811881188,
      answerWeightedShare: 0.24249916762692741,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Is Inclusive And Welcoming To All Types Of People',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 391.2211679133392,
      CurrentNumeratorUnWeighted_Answer: 403,
      CurrentNumeratorUnWeighted_Total: 403,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 391.2211679133392,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651893,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_8',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.22337363270005758,
      totalWeightedShare: 0.2144812645541809,
      answerUnweightedShare: 0.2400990099009901,
      answerWeightedShare: 0.23092826197687838,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Helps People Start Saving',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 372.553956530612,
      CurrentNumeratorUnWeighted_Answer: 388,
      CurrentNumeratorUnWeighted_Total: 388,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 372.553956530612,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651894,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_9',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.16062176165803108,
      totalWeightedShare: 0.15452161809593604,
      answerUnweightedShare: 0.17264851485148514,
      answerWeightedShare: 0.16637074934689855,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has A Great Digital Experience',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 268.40405063264075,
      CurrentNumeratorUnWeighted_Answer: 279,
      CurrentNumeratorUnWeighted_Total: 279,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 268.40405063264075,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651895,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.27518710420264825,
      totalWeightedShare: 0.2710290706660688,
      answerUnweightedShare: 0.2957920792079208,
      answerWeightedShare: 0.2918123052109904,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Is Trustworthy And Reliable',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 470.7774957469612,
      CurrentNumeratorUnWeighted_Answer: 478,
      CurrentNumeratorUnWeighted_Total: 478,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 470.7774957469612,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651866,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_10',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.1894070236039148,
      totalWeightedShare: 0.18260935525743285,
      answerUnweightedShare: 0.20358910891089108,
      answerWeightedShare: 0.1966123293704503,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Offers Intuitive & Helpful Financial Planning Tools',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 317.1924500821607,
      CurrentNumeratorUnWeighted_Answer: 329,
      CurrentNumeratorUnWeighted_Total: 329,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 317.1924500821607,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651867,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_11',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.1421991940126655,
      totalWeightedShare: 0.13625110049555145,
      answerUnweightedShare: 0.15284653465346534,
      answerWeightedShare: 0.1466991995560824,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has All The Trading Tools And Tech I Need',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 236.66816156077275,
      CurrentNumeratorUnWeighted_Answer: 247,
      CurrentNumeratorUnWeighted_Total: 247,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 236.66816156077275,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651868,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_12',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.27691421991940124,
      totalWeightedShare: 0.2743969120324833,
      answerUnweightedShare: 0.29764851485148514,
      answerWeightedShare: 0.29543840166737095,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Imagery | Has A Broad Range Of Products To Help With Saving And Investing',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 476.6274362004232,
      CurrentNumeratorUnWeighted_Answer: 481,
      CurrentNumeratorUnWeighted_Total: 480.99999999999994,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 476.62743620042323,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651869,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_13',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.0667818077144502,
      totalWeightedShare: 0.05276368681398985,
      answerUnweightedShare: 0.07178217821782178,
      answerWeightedShare: 0.056809747540298605,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Offers Free Trading/zero Commissions',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 91.65052399590033,
      CurrentNumeratorUnWeighted_Answer: 115.99999999999999,
      CurrentNumeratorUnWeighted_Total: 116.00000000000001,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 91.65052399590033,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651870,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_14',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.0846286701208981,
      totalWeightedShare: 0.08323534677910956,
      answerUnweightedShare: 0.09096534653465346,
      answerWeightedShare: 0.08961805594859752,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has A $0 Minimum To Open An Account',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 144.57979735531322,
      CurrentNumeratorUnWeighted_Answer: 147,
      CurrentNumeratorUnWeighted_Total: 147,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 144.57979735531322,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651871,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_15',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.14507772020725387,
      totalWeightedShare: 0.1420513175207043,
      answerUnweightedShare: 0.15594059405940594,
      answerWeightedShare: 0.15294419274693938,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Is Clear And Transparent About All Fees',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 246.74313853346328,
      CurrentNumeratorUnWeighted_Answer: 252,
      CurrentNumeratorUnWeighted_Total: 251.99999999999997,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 246.74313853346322,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651872,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_16',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.14335060449050085,
      totalWeightedShare: 0.13484446535806427,
      answerUnweightedShare: 0.15408415841584158,
      answerWeightedShare: 0.14518469987140967,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Imagery | Provides Clear Recommendations And Next Steps To Act On',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 234.22483632695753,
      CurrentNumeratorUnWeighted_Answer: 249,
      CurrentNumeratorUnWeighted_Total: 248.99999999999997,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 234.2248363269575,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651873,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_17',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.19228554979850315,
      totalWeightedShare: 0.19631342311467878,
      answerUnweightedShare: 0.20668316831683167,
      answerWeightedShare: 0.21136726182977275,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Imagery | Is A Trusted Source Of Help When Navigating Key Life Events',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 340.9964159501969,
      CurrentNumeratorUnWeighted_Answer: 334,
      CurrentNumeratorUnWeighted_Total: 334,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 340.9964159501969,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651874,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_18',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.17731721358664365,
      totalWeightedShare: 0.1771778581130703,
      answerUnweightedShare: 0.1905940594059406,
      answerWeightedShare: 0.19076433048771727,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Is A Brand For Me Today',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 307.75793954240294,
      CurrentNumeratorUnWeighted_Answer: 308,
      CurrentNumeratorUnWeighted_Total: 308,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 307.75793954240294,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651875,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Familiarity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.08071748878923767,
      totalWeightedShare: 0.06689882079623476,
      answerUnweightedShare: 0.08071748878923767,
      answerWeightedShare: 0.06689882079623476,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Familiarity | Do business with most often/Primary Provider(s)',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 104.42905926292242,
      CurrentNumeratorUnWeighted_Answer: 126,
      CurrentNumeratorUnWeighted_Total: 126,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 104.42905926292242,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 270748,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Familiarity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.18898142216527866,
      totalWeightedShare: 0.18081246948429253,
      answerUnweightedShare: 0.18898142216527866,
      answerWeightedShare: 0.18081246948429253,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '2',
      colResponseCode: '',
      rowChild: 'Familiarity | Do business with currently',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 282.24826486498057,
      CurrentNumeratorUnWeighted_Answer: 295,
      CurrentNumeratorUnWeighted_Total: 295,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 282.24826486498057,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 270749,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Familiarity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.10698270339525945,
      totalWeightedShare: 0.09828717486671287,
      answerUnweightedShare: 0.10698270339525945,
      answerWeightedShare: 0.09828717486671287,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '3',
      colResponseCode: '',
      rowChild:
        'Familiarity | Have done business with in the past, but not currently',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 153.42627996693875,
      CurrentNumeratorUnWeighted_Answer: 167,
      CurrentNumeratorUnWeighted_Total: 167,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 153.42627996693875,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 270750,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Familiarity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.27482383087764256,
      totalWeightedShare: 0.271671815686586,
      answerUnweightedShare: 0.27482383087764256,
      answerWeightedShare: 0.271671815686586,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '4',
      colResponseCode: '',
      rowChild: 'Familiarity | Heard a lot about, but never did business with',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 424.0797042867606,
      CurrentNumeratorUnWeighted_Answer: 429.00000000000006,
      CurrentNumeratorUnWeighted_Total: 429.00000000000006,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 424.0797042867606,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 270751,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Familiarity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.27994875080076875,
      totalWeightedShare: 0.31256489823269384,
      answerUnweightedShare: 0.27994875080076875,
      answerWeightedShare: 0.31256489823269384,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '5',
      colResponseCode: '',
      rowChild:
        'Familiarity | Heard a little about, but never did business with',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 487.91380614123494,
      CurrentNumeratorUnWeighted_Answer: 437,
      CurrentNumeratorUnWeighted_Total: 437,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 487.91380614123494,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 270752,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Familiarity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.06854580397181294,
      totalWeightedShare: 0.06976482093347991,
      answerUnweightedShare: 0.06854580397181294,
      answerWeightedShare: 0.06976482093347991,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '6',
      colResponseCode: '',
      rowChild: 'Familiarity | Never heard of them',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 108.9028854771621,
      CurrentNumeratorUnWeighted_Answer: 107,
      CurrentNumeratorUnWeighted_Total: 107,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 108.9028854771621,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 270753,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_19',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.20435618193465727,
      totalWeightedShare: 0.1999070337884776,
      answerUnweightedShare: 0.21939477303988997,
      answerWeightedShare: 0.2148994558441468,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Is A Brand For Me In The Future',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 312.05487974381344,
      CurrentNumeratorUnWeighted_Answer: 319,
      CurrentNumeratorUnWeighted_Total: 319,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 312.05487974381344,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651876,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_2',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.18834080717488788,
      totalWeightedShare: 0.17963350368778003,
      answerUnweightedShare: 0.20220082530949107,
      answerWeightedShare: 0.1931054723903692,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Provides A Personalized Experience',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 280.40789925662455,
      CurrentNumeratorUnWeighted_Answer: 294,
      CurrentNumeratorUnWeighted_Total: 294,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 280.40789925662455,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651877,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_20',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.38244714926329276,
      totalWeightedShare: 0.3743085480587824,
      answerUnweightedShare: 0.41059147180192573,
      answerWeightedShare: 0.4023805554573808,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | No answer',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 584.2956435197591,
      CurrentNumeratorUnWeighted_Answer: 597,
      CurrentNumeratorUnWeighted_Total: 597,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 584.2956435197591,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651878,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_21',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has An Easy To Navigate Website',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651879,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_22',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has An Easy To Use App',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651880,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_23',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Is A Brand For Me',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651881,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_24',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has Best-in-class Online Security',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651882,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_25',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Provides Educational Resources',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651883,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_26',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Shares Meaningful Insights Related To Your Finances',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651884,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_27',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has Expert Financial Advisors',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651885,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_28',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Understands And Respects Your Culture',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651886,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_29',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Helps You Realize Your Financial Possibilities',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651887,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_3',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.20691864189622036,
      totalWeightedShare: 0.21698477237400368,
      answerUnweightedShare: 0.2221458046767538,
      answerWeightedShare: 0.23325797309852908,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Is Easy To Do Business With',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 338.71322967581966,
      CurrentNumeratorUnWeighted_Answer: 323,
      CurrentNumeratorUnWeighted_Total: 323,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 338.71322967581966,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651888,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_30',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0,
      totalWeightedShare: 0,
      answerUnweightedShare: null,
      answerWeightedShare: null,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Looks Out For Your Best Interest',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 0,
      answerWeightedBase: 0,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Answer: null,
      CurrentNumeratorUnWeighted_Total: 0,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 0,
      CurrentBaseUnWeighted_Answer: 0,
      CurrentNumeratorWeighted_Total: 0,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: null,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651889,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_4',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.2139654067905189,
      totalWeightedShare: 0.21839496213272713,
      answerUnweightedShare: 0.2297111416781293,
      answerWeightedShare: 0.2347739228179737,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has Excellent Customer Service',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 340.91453588918694,
      CurrentNumeratorUnWeighted_Answer: 334,
      CurrentNumeratorUnWeighted_Total: 334,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 340.91453588918694,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651890,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_5',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.15246636771300448,
      totalWeightedShare: 0.1407778576664794,
      answerUnweightedShare: 0.16368638239339753,
      answerWeightedShare: 0.15133577060345998,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has A Positive Impact On The World Around Me',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 219.75423581737425,
      CurrentNumeratorUnWeighted_Answer: 238,
      CurrentNumeratorUnWeighted_Total: 238,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 219.75423581737428,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651891,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_6',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.13452914798206278,
      totalWeightedShare: 0.13749393469593715,
      answerUnweightedShare: 0.14442916093535077,
      answerWeightedShare: 0.14780556335647368,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Helps Less Experienced Investors Get Started',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 214.62803206035784,
      CurrentNumeratorUnWeighted_Answer: 210.00000000000003,
      CurrentNumeratorUnWeighted_Total: 210,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 214.62803206035784,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651892,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_7',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.2267777065983344,
      totalWeightedShare: 0.21992301301424802,
      answerUnweightedShare: 0.24346629986244842,
      answerWeightedShare: 0.23641657288744783,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Is Inclusive And Welcoming To All Types Of People',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 343.29982331524104,
      CurrentNumeratorUnWeighted_Answer: 354,
      CurrentNumeratorUnWeighted_Total: 354,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 343.29982331524104,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651893,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_8',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.19730941704035873,
      totalWeightedShare: 0.19968167214712973,
      answerUnweightedShare: 0.21182943603851445,
      answerWeightedShare: 0.2146571927622732,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Helps People Start Saving',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 311.7030902216694,
      CurrentNumeratorUnWeighted_Answer: 308,
      CurrentNumeratorUnWeighted_Total: 308,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 311.7030902216694,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651894,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_9',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.1627162075592569,
      totalWeightedShare: 0.1642405380857644,
      answerUnweightedShare: 0.1746905089408528,
      answerWeightedShare: 0.1765580809904199,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has A Great Digital Experience',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 256.3794799518781,
      CurrentNumeratorUnWeighted_Answer: 253.99999999999997,
      CurrentNumeratorUnWeighted_Total: 254,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 256.3794799518781,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651895,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.27994875080076875,
      totalWeightedShare: 0.2822721208355832,
      answerUnweightedShare: 0.3005502063273728,
      answerWeightedShare: 0.30344167495239205,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Is Trustworthy And Reliable',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 440.6267806243452,
      CurrentNumeratorUnWeighted_Answer: 437,
      CurrentNumeratorUnWeighted_Total: 437,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 440.6267806243452,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651866,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_10',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.19282511210762332,
      totalWeightedShare: 0.19070205257939563,
      answerUnweightedShare: 0.20701513067400276,
      answerWeightedShare: 0.20500412892443273,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Offers Intuitive & Helpful Financial Planning Tools',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 297.6859040764365,
      CurrentNumeratorUnWeighted_Answer: 301,
      CurrentNumeratorUnWeighted_Total: 301,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 297.6859040764365,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651867,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_11',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.16143497757847533,
      totalWeightedShare: 0.16290904820687124,
      answerUnweightedShare: 0.1733149931224209,
      answerWeightedShare: 0.1751267334034266,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has All The Trading Tools And Tech I Need',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 254.30102425092596,
      CurrentNumeratorUnWeighted_Answer: 252,
      CurrentNumeratorUnWeighted_Total: 252,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 254.30102425092593,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651868,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_12',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.2709801409352979,
      totalWeightedShare: 0.27449146175702316,
      answerUnweightedShare: 0.2909215955983494,
      answerWeightedShare: 0.2950774900090019,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Imagery | Has A Broad Range Of Products To Help With Saving And Investing',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 428.481171802713,
      CurrentNumeratorUnWeighted_Answer: 423.00000000000006,
      CurrentNumeratorUnWeighted_Total: 423,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 428.48117180271305,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651869,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_13',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.06726457399103139,
      totalWeightedShare: 0.05787742444648873,
      answerUnweightedShare: 0.07221458046767538,
      answerWeightedShare: 0.06221805598081987,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Offers Free Trading/zero Commissions',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 90.34665956096889,
      CurrentNumeratorUnWeighted_Answer: 105.00000000000001,
      CurrentNumeratorUnWeighted_Total: 105,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 90.34665956096889,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651870,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_14',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.07623318385650224,
      totalWeightedShare: 0.0673240356452783,
      answerUnweightedShare: 0.08184319119669876,
      answerWeightedShare: 0.07237313440762064,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Has A $0 Minimum To Open An Account',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 105.0928196422794,
      CurrentNumeratorUnWeighted_Answer: 119,
      CurrentNumeratorUnWeighted_Total: 119,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 105.09281964227938,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651871,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_15',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.1620755925688661,
      totalWeightedShare: 0.1592570598386462,
      answerUnweightedShare: 0.17400275103163687,
      answerWeightedShare: 0.1712008569687278,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Is Clear And Transparent About All Fees',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 248.60027040812662,
      CurrentNumeratorUnWeighted_Answer: 253,
      CurrentNumeratorUnWeighted_Total: 253,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 248.60027040812662,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651872,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_16',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.1620755925688661,
      totalWeightedShare: 0.1548081301792788,
      answerUnweightedShare: 0.17400275103163687,
      answerWeightedShare: 0.16641827105982696,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Imagery | Provides Clear Recommendations And Next Steps To Act On',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 241.65549120985412,
      CurrentNumeratorUnWeighted_Answer: 253,
      CurrentNumeratorUnWeighted_Total: 253,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 241.65549120985415,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651873,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_17',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.18385650224215247,
      totalWeightedShare: 0.18247550757967984,
      answerUnweightedShare: 0.19738651994497936,
      answerWeightedShare: 0.1961606179662995,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild:
        'Imagery | Is A Trusted Source Of Help When Navigating Key Life Events',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 284.84426733188013,
      CurrentNumeratorUnWeighted_Answer: 287,
      CurrentNumeratorUnWeighted_Total: 287,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 284.84426733188013,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651874,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 3,
      widgetName: 'Imagery Association',
      WidgetMetrics: '',
      pageNumber: 2,
      colVariableCode: '',
      rowVariableCode: 'ImageryFlip_1_18',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.19987187700192185,
      totalWeightedShare: 0.20302315279461822,
      answerUnweightedShare: 0.21458046767537828,
      answerWeightedShare: 0.21824927433764604,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Imagery | Is A Brand For Me Today',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 316.91914151239894,
      CurrentNumeratorUnWeighted_Answer: 312,
      CurrentNumeratorUnWeighted_Total: 312,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 316.91914151239894,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 651875,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 4,
      widgetName: 'Perception Metrics',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'DynamicDA_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.24582613701784686,
      totalWeightedShare: 0.2508210261988654,
      answerUnweightedShare: 0.26423267326732675,
      answerWeightedShare: 0.2700546538074391,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '7|6',
      colResponseCode: '',
      rowChild: 'Dynamic | Top2Box',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: true,
      CalculationType: 'RespGrp',
      CurrentNumeratorWeighted_Answer: 435.6761225074291,
      CurrentNumeratorUnWeighted_Answer: 427,
      CurrentNumeratorUnWeighted_Total: 427,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 435.676122507429,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 732876,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 4,
      widgetName: 'Perception Metrics',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'MeetsNeedsDA_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.2867012089810017,
      totalWeightedShare: 0.28463350559870254,
      answerUnweightedShare: 0.30816831683168316,
      answerWeightedShare: 0.306459964626375,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '7|6',
      colResponseCode: '',
      rowChild: 'Meets Needs | Top2Box',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: true,
      CalculationType: 'RespGrp',
      CurrentNumeratorWeighted_Answer: 494.408399224946,
      CurrentNumeratorUnWeighted_Answer: 498,
      CurrentNumeratorUnWeighted_Total: 497.99999999999994,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 494.40839922494604,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 743113,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 4,
      widgetName: 'Perception Metrics',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'AffinityDA_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.284398388025331,
      totalWeightedShare: 0.27961481620210393,
      answerUnweightedShare: 0.3056930693069307,
      answerWeightedShare: 0.3010564286943797,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '3|2',
      colResponseCode: '',
      rowChild: 'Affinity | Top2Box',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: true,
      CalculationType: 'RespGrp',
      CurrentNumeratorWeighted_Answer: 485.69093574305424,
      CurrentNumeratorUnWeighted_Answer: 494,
      CurrentNumeratorUnWeighted_Total: 494,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 485.6909357430543,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 722639,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 4,
      widgetName: 'Perception Metrics',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'UniqueDA_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.1888313183649971,
      totalWeightedShare: 0.18090799212053085,
      answerUnweightedShare: 0.20297029702970298,
      answerWeightedShare: 0.19478050115453144,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '7|6',
      colResponseCode: '',
      rowChild: 'Unique (Different) | Top2Box',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: true,
      CalculationType: 'RespGrp',
      CurrentNumeratorWeighted_Answer: 314.2371823133619,
      CurrentNumeratorUnWeighted_Answer: 328,
      CurrentNumeratorUnWeighted_Total: 328,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 314.2371823133619,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 753349,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 4,
      widgetName: 'Perception Metrics',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'DynamicDA_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.24855861627162076,
      totalWeightedShare: 0.23745489123452293,
      answerUnweightedShare: 0.2668500687757909,
      answerWeightedShare: 0.2552632888736869,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '7|6',
      colResponseCode: '',
      rowChild: 'Dynamic | Top2Box',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: true,
      CalculationType: 'RespGrp',
      CurrentNumeratorWeighted_Answer: 370.6670852170902,
      CurrentNumeratorUnWeighted_Answer: 388,
      CurrentNumeratorUnWeighted_Total: 388,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 370.6670852170902,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 732876,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 4,
      widgetName: 'Perception Metrics',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'MeetsNeedsDA_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.32286995515695066,
      totalWeightedShare: 0.31055980545955403,
      answerUnweightedShare: 0.3466299862448418,
      answerWeightedShare: 0.3338508502454155,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '7|6',
      colResponseCode: '',
      rowChild: 'Meets Needs | Top2Box',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: true,
      CalculationType: 'RespGrp',
      CurrentNumeratorWeighted_Answer: 484.7838563223637,
      CurrentNumeratorUnWeighted_Answer: 504,
      CurrentNumeratorUnWeighted_Total: 504,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 484.7838563223637,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 743113,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 4,
      widgetName: 'Perception Metrics',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'AffinityDA_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.3145419602818706,
      totalWeightedShare: 0.3094177553312144,
      answerUnweightedShare: 0.33768913342503437,
      answerWeightedShare: 0.33262314981649205,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '3|2',
      colResponseCode: '',
      rowChild: 'Affinity | Top2Box',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: true,
      CalculationType: 'RespGrp',
      CurrentNumeratorWeighted_Answer: 483.0011160720255,
      CurrentNumeratorUnWeighted_Answer: 491,
      CurrentNumeratorUnWeighted_Total: 491,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 483.0011160720255,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 722639,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 4,
      widgetName: 'Perception Metrics',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'UniqueDA_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.20948110185778346,
      totalWeightedShare: 0.2011740410746506,
      answerUnweightedShare: 0.2248968363136176,
      answerWeightedShare: 0.21626148483927082,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '7|6',
      colResponseCode: '',
      rowChild: 'Unique (Different) | Top2Box',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: true,
      CalculationType: 'RespGrp',
      CurrentNumeratorWeighted_Answer: 314.0326781175295,
      CurrentNumeratorUnWeighted_Answer: 327,
      CurrentNumeratorUnWeighted_Total: 327,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 314.0326781175295,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 753349,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 5,
      widgetName: 'Brand Equity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'BrandPowerGridPower_01',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 1,
      totalWeightedShare: 0.09022714615259525,
      answerUnweightedShare: 1,
      answerWeightedShare: 0.09022714615259525,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '',
      colResponseCode: '',
      rowChild: 'Mean-Brand Power Grid-Brand Power',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: true,
      CalculationType: 'mean',
      CurrentNumeratorWeighted_Answer: 156.72455286705787,
      CurrentNumeratorUnWeighted_Answer: 1737,
      CurrentNumeratorUnWeighted_Total: 1737,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 156.72455286705787,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 341228,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 5,
      widgetName: 'Brand Equity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'BrandPowerGridMFI_01',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 1,
      totalWeightedShare: 121.22950568953367,
      answerUnweightedShare: 1,
      answerWeightedShare: 121.22950568953367,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '',
      colResponseCode: '',
      rowChild: 'Mean-Brand Power Grid-Meaningful Index',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1616,
      totalWeightedBase: 1613.28870421202,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: true,
      CalculationType: 'mean',
      CurrentNumeratorWeighted_Answer: 195578.19214613148,
      CurrentNumeratorUnWeighted_Answer: 1616,
      CurrentNumeratorUnWeighted_Total: 1616,
      CurrentBaseUnWeighted_Total: 1616,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 195578.19214613148,
      CurrentBaseWeighted_Total: 1613.28870421202,
      TotalEbaseE1: 1038.804934300693,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 351244,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 5,
      widgetName: 'Brand Equity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'BrandPowerGridDFI_01',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 1,
      totalWeightedShare: 88.79931093767783,
      answerUnweightedShare: 1,
      answerWeightedShare: 88.79931093767783,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '',
      colResponseCode: '',
      rowChild: 'Mean-Brand Power Grid-Difference Index',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1616,
      totalWeightedBase: 1613.28870421202,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: true,
      CalculationType: 'mean',
      CurrentNumeratorWeighted_Answer: 143258.92527756654,
      CurrentNumeratorUnWeighted_Answer: 1616,
      CurrentNumeratorUnWeighted_Total: 1616,
      CurrentBaseUnWeighted_Total: 1616,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 143258.92527756654,
      CurrentBaseWeighted_Total: 1613.28870421202,
      TotalEbaseE1: 1038.804934300693,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 361260,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 5,
      widgetName: 'Brand Equity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'BrandPowerGridSFI_01',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 1,
      totalWeightedShare: 115.74382513320664,
      answerUnweightedShare: 1,
      answerWeightedShare: 115.74382513320664,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '',
      colResponseCode: '',
      rowChild: 'Mean-Brand Power Grid-Salience Index',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1616,
      totalWeightedBase: 1613.28870421202,
      answerUnweightedBase: 1616,
      answerWeightedBase: 1613.28870421202,
      isDerived: true,
      CalculationType: 'mean',
      CurrentNumeratorWeighted_Answer: 186728.2056696936,
      CurrentNumeratorUnWeighted_Answer: 1616,
      CurrentNumeratorUnWeighted_Total: 1616,
      CurrentBaseUnWeighted_Total: 1616,
      CurrentBaseWeighted_Answer: 1613.28870421202,
      CurrentBaseUnWeighted_Answer: 1616,
      CurrentNumeratorWeighted_Total: 186728.2056696936,
      CurrentBaseWeighted_Total: 1613.28870421202,
      TotalEbaseE1: 1038.804934300693,
      AnswerEbaseE1: 1038.804934300693,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 371276,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 5,
      widgetName: 'Brand Equity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'BrandPowerGridPower_01',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 1,
      totalWeightedShare: 0.0927012449298038,
      answerUnweightedShare: 1,
      answerWeightedShare: 0.0927012449298038,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '',
      colResponseCode: '',
      rowChild: 'Mean-Brand Power Grid-Brand Power',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: true,
      CalculationType: 'mean',
      CurrentNumeratorWeighted_Answer: 144.7066433354237,
      CurrentNumeratorUnWeighted_Answer: 1561,
      CurrentNumeratorUnWeighted_Total: 1561,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 144.7066433354237,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 341228,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 5,
      widgetName: 'Brand Equity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'BrandPowerGridMFI_01',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 1,
      totalWeightedShare: 123.36784115049258,
      answerUnweightedShare: 1,
      answerWeightedShare: 123.36784115049258,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '',
      colResponseCode: '',
      rowChild: 'Mean-Brand Power Grid-Meaningful Index',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1454,
      totalWeightedBase: 1452.0971145228373,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: true,
      CalculationType: 'mean',
      CurrentNumeratorWeighted_Answer: 179142.08615954203,
      CurrentNumeratorUnWeighted_Answer: 1454,
      CurrentNumeratorUnWeighted_Total: 1454,
      CurrentBaseUnWeighted_Total: 1454,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 179142.08615954203,
      CurrentBaseWeighted_Total: 1452.0971145228373,
      TotalEbaseE1: 1011.3489856351067,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 351244,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 5,
      widgetName: 'Brand Equity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'BrandPowerGridDFI_01',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 1,
      totalWeightedShare: 88.61301970940035,
      answerUnweightedShare: 1,
      answerWeightedShare: 88.61301970940035,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '',
      colResponseCode: '',
      rowChild: 'Mean-Brand Power Grid-Difference Index',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1454,
      totalWeightedBase: 1452.0971145228373,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: true,
      CalculationType: 'mean',
      CurrentNumeratorWeighted_Answer: 128674.71022917556,
      CurrentNumeratorUnWeighted_Answer: 1454,
      CurrentNumeratorUnWeighted_Total: 1454,
      CurrentBaseUnWeighted_Total: 1454,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 128674.71022917556,
      CurrentBaseWeighted_Total: 1452.0971145228373,
      TotalEbaseE1: 1011.3489856351067,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 361260,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 5,
      widgetName: 'Brand Equity',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'BrandPowerGridSFI_01',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 1,
      totalWeightedShare: 122.188380576898,
      answerUnweightedShare: 1,
      answerWeightedShare: 122.188380576898,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '',
      colResponseCode: '',
      rowChild: 'Mean-Brand Power Grid-Salience Index',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1454,
      totalWeightedBase: 1452.0971145228373,
      answerUnweightedBase: 1454,
      answerWeightedBase: 1452.0971145228373,
      isDerived: true,
      CalculationType: 'mean',
      CurrentNumeratorWeighted_Answer: 177429.39486393187,
      CurrentNumeratorUnWeighted_Answer: 1454,
      CurrentNumeratorUnWeighted_Total: 1454,
      CurrentBaseUnWeighted_Total: 1454,
      CurrentBaseWeighted_Answer: 1452.0971145228373,
      CurrentBaseUnWeighted_Answer: 1454,
      CurrentNumeratorWeighted_Total: 177429.39486393187,
      CurrentBaseWeighted_Total: 1452.0971145228373,
      TotalEbaseE1: 1011.3489856351067,
      AnswerEbaseE1: 1011.3489856351067,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 371276,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 6,
      widgetName: 'Brand Funnel',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'UnAwareTotalM_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.14335060449050085,
      totalWeightedShare: 0.14213253891433916,
      answerUnweightedShare: 0.14335060449050085,
      answerWeightedShare: 0.14213253891433916,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Unaided Awareness Total Mentions',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 246.884220094207,
      CurrentNumeratorUnWeighted_Answer: 248.99999999999997,
      CurrentNumeratorUnWeighted_Total: 248.99999999999997,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 246.884220094207,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 180295,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 6,
      widgetName: 'Brand Funnel',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'UnConstTotalM_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.10765687967760507,
      totalWeightedShare: 0.11173433695448479,
      answerUnweightedShare: 0.10765687967760507,
      answerWeightedShare: 0.11173433695448479,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Unaided Consideration Total Mentions',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 194.08254328993996,
      CurrentNumeratorUnWeighted_Answer: 187,
      CurrentNumeratorUnWeighted_Total: 187,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 194.08254328993996,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 260609,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 6,
      widgetName: 'Brand Funnel',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamTriedStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.37535981577432354,
      totalWeightedShare: 0.3691483806034747,
      answerUnweightedShare: 0.37535981577432354,
      answerWeightedShare: 0.3691483806034747,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Ever Used Brand',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 641.2107371082352,
      CurrentNumeratorUnWeighted_Answer: 652,
      CurrentNumeratorUnWeighted_Total: 652,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 641.2107371082352,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 421292,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 6,
      widgetName: 'Brand Funnel',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamT2BStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.25503742084052966,
      totalWeightedShare: 0.2420809642953727,
      answerUnweightedShare: 0.25503742084052966,
      answerWeightedShare: 0.2420809642953727,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Currently Used Brand',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 420.4946349810622,
      CurrentNumeratorUnWeighted_Answer: 443,
      CurrentNumeratorUnWeighted_Total: 443,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 420.4946349810622,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 431312,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 6,
      widgetName: 'Brand Funnel',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'PrimaryProviderBrandDP_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.08175014392630973,
      totalWeightedShare: 0.08126428420077486,
      answerUnweightedShare: 0.08175014392630973,
      answerWeightedShare: 0.08126428420077486,
      Level1ColResponseCode: '6 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Primary Provider Brand',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|Jun_2023',
      totalUnweightedBase: 1737,
      totalWeightedBase: 1736.999999999999,
      answerUnweightedBase: 1737,
      answerWeightedBase: 1736.999999999999,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 141.15606165674586,
      CurrentNumeratorUnWeighted_Answer: 142,
      CurrentNumeratorUnWeighted_Total: 142,
      CurrentBaseUnWeighted_Total: 1737,
      CurrentBaseWeighted_Answer: 1736.999999999999,
      CurrentBaseUnWeighted_Answer: 1737,
      CurrentNumeratorWeighted_Total: 141.15606165674586,
      CurrentBaseWeighted_Total: 1736.999999999999,
      TotalEbaseE1: 1105.3613385137905,
      AnswerEbaseE1: 1105.3613385137905,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 441328,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 6,
      widgetName: 'Brand Funnel',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'UnAwareTotalM_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.14862267777065982,
      totalWeightedShare: 0.1456336679502565,
      answerUnweightedShare: 0.14862267777065982,
      answerWeightedShare: 0.1456336679502565,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Unaided Awareness Total Mentions',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 227.33415567035033,
      CurrentNumeratorUnWeighted_Answer: 231.99999999999997,
      CurrentNumeratorUnWeighted_Total: 231.99999999999997,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 227.33415567035033,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 180295,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 6,
      widgetName: 'Brand Funnel',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'UnConstTotalM_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.12235746316463805,
      totalWeightedShare: 0.12470347569659147,
      answerUnweightedShare: 0.12235746316463805,
      answerWeightedShare: 0.12470347569659147,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Unaided Consideration Total Mentions',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 194.66212556237923,
      CurrentNumeratorUnWeighted_Answer: 191,
      CurrentNumeratorUnWeighted_Total: 191,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 194.66212556237923,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 260609,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 6,
      widgetName: 'Brand Funnel',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamTriedStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.37668161434977576,
      totalWeightedShare: 0.3459984651472402,
      answerUnweightedShare: 0.37668161434977576,
      answerWeightedShare: 0.3459984651472402,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Ever Used Brand',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 540.1036040948418,
      CurrentNumeratorUnWeighted_Answer: 588,
      CurrentNumeratorUnWeighted_Total: 588,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 540.1036040948418,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 421292,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 6,
      widgetName: 'Brand Funnel',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'FamT2BStd_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.2696989109545163,
      totalWeightedShare: 0.2477112902805273,
      answerUnweightedShare: 0.2696989109545163,
      answerWeightedShare: 0.2477112902805273,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Currently Used Brand',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 386.677324127903,
      CurrentNumeratorUnWeighted_Answer: 420.99999999999994,
      CurrentNumeratorUnWeighted_Total: 420.99999999999994,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 386.677324127903,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 431312,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
    {
      pairWiseValues: [],
      widgetNumber: 6,
      widgetName: 'Brand Funnel',
      WidgetMetrics: '',
      pageNumber: 1,
      colVariableCode: '',
      rowVariableCode: 'PrimaryProviderBrandDP_1',
      Level1NestColVariableCode: 'Month_code',
      Level2NestColVariableCode: null,
      Level1NestRowVariableCode: null,
      Level2NestRowVariableCode: null,
      totalUnweightedShare: 0.08071748878923767,
      totalWeightedShare: 0.06689882079623476,
      answerUnweightedShare: 0.08071748878923767,
      answerWeightedShare: 0.06689882079623476,
      Level1ColResponseCode: '5 2023',
      Level2ColResponseCode: null,
      Level1RowResponseCode: null,
      Level2RowResponseCode: null,
      rowResponseCode: '1',
      colResponseCode: '',
      rowChild: 'Primary Provider Brand',
      colChild: 'Brands|JP Morgan Chase',
      Level1RowChild: null,
      Level2RowChild: null,
      Level2ColChild: null,
      Level1ColChild: 'Month|May_2023',
      totalUnweightedBase: 1561,
      totalWeightedBase: 1560.9999999999995,
      answerUnweightedBase: 1561,
      answerWeightedBase: 1560.9999999999995,
      isDerived: false,
      CalculationType: 'share',
      CurrentNumeratorWeighted_Answer: 104.42905926292242,
      CurrentNumeratorUnWeighted_Answer: 126,
      CurrentNumeratorUnWeighted_Total: 126,
      CurrentBaseUnWeighted_Total: 1561,
      CurrentBaseWeighted_Answer: 1560.9999999999995,
      CurrentBaseUnWeighted_Answer: 1561,
      CurrentNumeratorWeighted_Total: 104.42905926292242,
      CurrentBaseWeighted_Total: 1560.9999999999995,
      TotalEbaseE1: 1096.6840864009873,
      AnswerEbaseE1: 1096.6840864009873,
      Significance_Total: null,
      Significance_Answer: null,
      sort_id: 441328,
      changeVsPY_Total: null,
      changeVsPY_Answer: null,
      standardDevidation: null,
      standardDevidation_Total: null,
      standardDevidation_Answer: null,
      isTotal: false,
      pairWiseHeader: null,
      isCustomGroup: false,
      customGroupId: '',
      isCustomCalculation: false,
      customCalculationId: null,
      removeBrand: 0,
      value: null,
    },
  ];
}
